import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { IPatientPersonalInfo } from 'src/app/models/IPatientPersonalInfo';
import { DatePipe, formatDate } from '@angular/common';
import { ConsentFormsClinicService } from 'src/app/Services/NewORNote/consentForm.service';
import { ToastrService } from 'ngx-toastr';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
import { PatientformService } from 'src/app/Services/PatientForms/patientform.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SignaturePad } from 'angular2-signaturepad/signature-pad';
import { IDocLibPatientForms, IDocLibPatientForms_Signatures } from 'src/app/models/IPatientForms';
import { warningDialogModel, WarningDialogComponent } from 'src/app/ChildControls/warning-dialog/warning-dialog.component';
import { MatAutocompleteTrigger, MatDialog, MatTabChangeEvent } from '@angular/material';
import { SchedularServiceService } from 'src/app/Services/Schedular/schedular-service.service';
import { ILocationDetails_ID_DocLibrary, IPatientDetails_DocLibrary } from 'src/app/models/IDocument';
import { DocumentLibraryService } from 'src/app/Services/DocumentLibrary/document-library.service';
import { IConsentMasterData_DocLibrary, IConsentNameMasterData_DocLibAll } from 'src/app/models/IDocumentLibrary';
import moment from 'moment';
import { DomSanitizer } from '@angular/platform-browser';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { Defaults } from 'src/app/Utilities/defaults';
import { InputDialogComponent } from 'src/app/ChildControls/input-dialog/input-dialog.component';
import { isNumeric } from 'rxjs/util/isNumeric';
import { ORNoteCommonService } from 'src/app/Services/NewORNote/orNoteCommon.service';
import { ProgressNotesService } from 'src/app/Services/NewVisitNote/progress-notes.service';
import { IReportParameters } from 'src/app/models/IReportParameters';
import { ShowSSRSReportComponent } from 'src/app/ChildControls/show-ssrsreport/show-ssrsreport.component';
import { UserManagementService } from 'src/app/Services/UserManagement/user-management.service';
import { AESAlgorithm } from 'src/app/Utilities/Crypto/AESAlgorithm';
import { LockService } from 'src/app/Services/LockService/lock-service.service';
import { ConfirmationDialogComponent } from 'src/app/ChildControls/confirmation-dialog/confirmation-dialog.component';
import { Observable, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import suneditor from 'suneditor';
import plugins from 'suneditor/src/plugins';
import { ConfirmDialogModel, DeleteDocumentComponent } from 'src/app/PatientChart/Document/delete-document/delete-document.component';
import { IEncounterData } from 'src/app/models/IEncounterData';
import { configuration } from 'src/environments/environment';
import { html } from 'd3';
import { debug } from 'console';

declare var $: any;
declare function Onclick_SingnaturePOP(Type): any;

@Component({
  selector: 'app-edit-consent-forms',
  templateUrl: './edit-consent-forms.component.html',
  styleUrls: ['./edit-consent-forms.component.css']
})
export class EditConsentFormsComponent implements OnInit {

  consentNameMasterDetails: IConsentNameMasterData_DocLibAll[];
  EditForms: FormGroup;
  //activetab = 10;
  activetab = 9;
  activeORtab = 1;
  submitted = false;
  showspinner = false;
  public hide: boolean = false;
  public personalInfo: IPatientPersonalInfo;
  public DoclibLocationInfo: ILocationDetails_ID_DocLibrary[];
  public DocLibPersonalInfo: IPatientDetails_DocLibrary[];
  public result: any;
  public patientNameById: number;
  // formName:string='';
  //@ViewChild(SignaturePad, null) signaturePad: SignaturePad;
  @ViewChild('sigPatient', null) signaturePad: SignaturePad;

  @ViewChild('sigpadoth', null) signaturePad2: SignaturePad;

  @ViewChild('ConsentForm', { read: MatAutocompleteTrigger, static: false }) ConsentForm: MatAutocompleteTrigger;
  @ViewChild('nurseName', { read: MatAutocompleteTrigger, static: false }) nurseName: MatAutocompleteTrigger;
  @ViewChild('clerkName', { read: MatAutocompleteTrigger, static: false }) clerkName: MatAutocompleteTrigger;
  @ViewChild('providerName', { read: MatAutocompleteTrigger, static: false }) providerName: MatAutocompleteTrigger;
  @ViewChild("sigPatient", null) sigPatient: SignaturePad;
  @ViewChild("sigpadoth", null) sigpadoth: SignaturePad;
  @ViewChild('ConsentForm', { static: false }) consentForm: ElementRef;

  signaturePad1: boolean = true;
  signaturePad3: boolean = true;
  softwareInstalled: boolean = true;
  softwareInstalled1: boolean = true;
  MyMouseSignaturePad: boolean = true;
  MyMouseSignaturePad1: boolean = true;
  Savesignaturebtn: boolean = false;

  public patientFormId: number;
  public DocLibTargetLocID: number;
  public widgetposition: number = 6;//3;
  labelHtml: any;
  content: any;
  _htmlstr: string;
  public Orginaldesc: string;
  public Removeslash: string;
  public ReplacedBRdesc: string;
  public ReplacedSPANdesc: string;
  public ReplacedLIdesc: string;
  public ReplacedLOdesc: string;
  public SelectedConsentMasterID: number;
  public CurentSigntureBY: number;

  public ISOthersSignature: boolean = false;
  public IsPatientSignature: boolean = false;
  public ISProviderSignature: boolean = false;
  public ISNurseSignature: boolean = false;
  public IsClerkSignature: boolean = false;
  public encounterId: string;
  public IsReadytoSignOff: boolean = false;

  IsAllSignsCompleted: boolean = false;
  signPadcheckPatient: boolean = false;
  signPadcheckWitness: boolean = false;
  PatientdivOrderid: number = 1;
  OtherdivOrderid: number = 2;
  NursedivOrderid: number = 3;
  ClerkdivOrderid: number = 4;
  ProviderdivOrderid: number = 5;
  public PatName: string;
  /*oderHtml1:number = 2;
  oderHtml2:number = 1;
  oderHtml3:number = 3;
  oderHtml4:number = 4;
  oderHtml5:number = 5;
*/
  DocLibConsentHtml: string;
  //templates onSelectionChange

  //templates:IConsentNameMasterData_DocLib[];
  signaturePadOptions = {
    minWidth: 0.4,
    maxWidth: 2,
    dotSize: 1.5,
    'canvasWidth': 300,
    'canvasHeight': 111,

  }
  signaturePadOptions1 = {
    minWidth: 0.4,
    maxWidth: 2,
    dotSize: 1.5,
    'canvasWidth': 300,
    'canvasHeight': 111,

  }

  headerVisibility: boolean;
  Doctype: string = "";

  canDeactivate(): Observable<boolean> | boolean {
    try {
      // if (this.isTabchange == true)
      //   return true;

      ;
      var unSaved = false;
      // $('#loaderRX').show();
      // $('#spdiv').show();
      //this.spinner.show();
      unSaved = this.labelHtml != this.content;



      //   this.fnDynamicFormSave(this.visibleDiv == "", true);
      // setTimeout(() => {


      if (unSaved) {
        // alert('deactivate fired');
        const result = window.confirm('There are unsaved changes! Are you sure to save and continue?');
        if (result) {

          this.SaveConsentforms('');
          setTimeout(() => {
            // this.orconsenttab = 0;
            //   this.initEditor.destroy();
          }, 1000);
        }
        else {
          //    this.initEditor.destroy();
        }
        // else                 
        // {
        //  this.orconsenttab = 0;
        //   this.activetab = 0;
        //   //alert('result fired');
        // }
        //this.spinner.hide();
        this.showspinner = false;
        return Observable.of(result);
      }
      // $('#loaderRX').hide();
      // $('#spdiv').hide();
      //this.spinner.hide();
      // }, 1000);
      // (this.ChiefStateMentForm.controls['painStatusList'] as FormArray).clear();
      // (this.ChiefStateMentForm.controls['PainStatusDetails'] as FormArray).clear();

      // this.ChiefStateMentForm.reset();
      // this.PainDatasource.data = [];
      // this.painstatuslist = [];

      return true;
    }
    catch (ex) {
      // $('#loaderRX').hide();
      // $('#spdiv').hide();
      this.showspinner = false;
      return true;
    }
  }
  OpenDialog(str: string): void {
    if (str == "Reset") {

      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        width: '300px',
        height: '150px',
        data: { headerText: 'Reset the Content will overwrite the existing data,Are you sure?' }
      });
      dialogRef.afterClosed().subscribe(result1 => {
        if (result1 && result1 != undefined) {
          // alert('confirmed');
          // this.onDocSubmit(this.docmentInfo);
          ;

          this.initEditor.setContents()
          var res = this.initEditor.setContents();
          // alert(res)
          // alert('result :: '+ this.labelHtml)
          //alert('reset :: '+ this.spanResetdata)
          $("#displayEditibleCheckboxId").html(this.spanResetdata)
          $("#editibleCheckboxId").html(this.spanResetdata);

          this.SaveConsentforms('Reset');

        } else {
          // alert('Cancelled');
          //this.docResult = result1;
        }
      });
    }

    else {
      if (this.IsEdit) {
        this.OnUpdateClick();
        setTimeout(() => {

        }, 1000);
      }
    }
  }
  constructor(//private app: AppComponent,
    public datepipe: DatePipe, private patientformService: PatientformService
    , private formBuilder: FormBuilder, private route: ActivatedRoute
    , private IConsentformsService: ConsentFormsClinicService
    , private toastr: ToastrService, private router: Router, public dialog: MatDialog
    , private dateservice: SchedularServiceService
    , private consentMasterService: DocumentLibraryService
    , private sanitizer: DomSanitizer
    , private sharedService: SharedService
    , private orNoteCommonService: ORNoteCommonService
    , private progressNotesService: ProgressNotesService
    , private _UserManagementService: UserManagementService
    , private crypto: AESAlgorithm
    , private lockService: LockService,
  ) {
    // this.removejscssfile("SignaturePadHandler.js", "js")
    // this.removejscssfile("SigWebTablet.js", "js")
    this.getAllProviders("Doctor");
    this.getAllProviders("Nurse");
    this.getAllProviders("Clerk");
    setTimeout(() => {

    }, 1000);
    // app.isLoggedIn$ = true;
    this.getSystem();
    this.refreshServerDateTime();
    // this.patientFormId = Number(this.route.snapshot.paramMap.get('patientFormId')); Nurse Clerk
    this.patientFormId = Number(this.route.snapshot.paramMap.get('DocLibPatientFormID'));
    this.DocLibTargetLocID = Number(this.route.snapshot.paramMap.get('DocLibTargetLocID'));
    if (this.DocLibTargetLocID == Defaults.DocLibraryCheckinForm) {
      this.Doctype = "Forms (Check-In)";
    }
    else if (this.DocLibTargetLocID == Defaults.DocLibraryVisitNote) {
      this.Doctype = "Forms (Visit Note)";
    }
    else if (this.DocLibTargetLocID == Defaults.DocLibraryORNote) {
      this.Doctype = "Forms (OR Note)";
    }
    else if (this.DocLibTargetLocID == Defaults.DocLibraryPatDemographicsID) {
      this.Doctype = "Forms (Demographics)";
    }

    CommonComponents.patientId = Number(sessionStorage.getItem("patientId"))

    this.encounterId = CommonComponents.encounterId;

    //this.GetProviderCalenderDetails('0');
    //  alert(sessionStorage.getItem("patientId"));
    // alert(sessionStorage.getItem("LocationId"));
    // this.getPatientFormDetailsById();

    this.headerVisibility = CommonComponents.demoheaderVisibility;
    this.getConsentDetails_Targetloc(this.DocLibTargetLocID, null);



    if (sessionStorage.getItem("LocationId") == null || sessionStorage.getItem("LocationId") == '' || sessionStorage.getItem("LocationId") == undefined) {


      this.sharedService.getLocationsByLoginUser().subscribe(async data => {
        Number(data);
        sessionStorage.setItem("LocationId", data);

      });
    }


    this.getPatientDetailsID(CommonComponents.patientId);
    this.getLocationDetaisID(Number(sessionStorage.getItem("LocationId")));

    this.checkLock();
    //this.getVisitIsSignedoff();
  }
  allconsentNameMasterDetails: IConsentNameMasterData_DocLibAll[];
  getHeaderLocationId(type: string) {
    if (type == "D")
      return Defaults.DocLibraryPatDemographicsID;
    else if (type == "C")
      return Defaults.DocLibraryCheckinForm;
    else if (type == "V")
      return Defaults.DocLibraryVisitNote;
    else if (type == "O")
      return Defaults.DocLibraryORNote;
  }
  getConsentDetails_Targetloc(targetLocID, obj) {
    ;
    //this.consentMasterService.getConsentMasterDetails_TargetLocid(targetLocID).subscribe(data=>{
    this.consentMasterService.getAllConsentMasterDetails_TargetLocid(targetLocID).subscribe(data => {

      if (targetLocID == Defaults.DocLibraryORNote) {
        data = this.RemoveElementFromObjectArray('IMPORTANT INSTRUCTIONS', data);
        data = this.RemoveElementFromObjectArray('Authorization And Consent', data);
        data = this.RemoveElementFromObjectArray('Spinal Cord Postoperative', data);
        //data = this.RemoveElementFromObjectArray('Vertiflex', data);
        data = this.RemoveElementFromObjectArray('COVID-19 Risk Disclosure', data);
      }

      this.allconsentNameMasterDetails = data;
      if (this.patientFormId == 0) {
        this.consentNameMasterDetails = data.filter(x => x.Isactive == true).sort((a, b) => a.ConsentName.localeCompare(b.ConsentName));
      }
      else {
        if (obj != null)

          data.push(obj);

        this.consentNameMasterDetails = data.sort((a, b) => a.ConsentName.localeCompare(b.ConsentName));
      }

      this.ConsentNameMasterDatafilter();
    })
  }
  RemoveElementFromObjectArray(key: string, data: IConsentNameMasterData_DocLibAll[]) {
    data.forEach((value, index) => {
      if (value.ConsentName == key) data.splice(index, 1);
    });
    return data;
  }
  getPatientDetailsID(PatientID) {

    this.consentMasterService.getPatientdetailsByIDDoclib(PatientID).subscribe(data => {
      this.DocLibPersonalInfo = data;
    })
  }

  getLocationDetaisID(LocationID) {

    this.consentMasterService.getLocationDetailsByIDDocLib(LocationID).subscribe(data => {
      this.DoclibLocationInfo = data;
    })
  }

  formErrors = {
    'practiceForm': '',
  };

  validationMessages = {
    'practiceForm': {
      'required': 'Practice Form is required.',
    },

  };
  _ServerdateTime: string; //siva
  IsEdit: boolean = false;
  OnEditClick() {
    $("span").css("pointer-events", "auto");
    this.IsEdit = !this.IsEdit;
    document.getElementById("editibleCheckbox").style.display = "none";
    document.getElementById("spanEditDivId").style.display = "block";

    var res=$("#displayEditibleCheckboxId").html();
    $("#editibleCheckboxId").html(res)

    // document.getElementById("editibleCheckbox").style.visibility = "visible";
    // document.getElementById("spanEditDivId").style.visibility = "hidden";

    // this.editactions();

    //   if (this.IsEdit === true) {
    //    $('.sun-editor .se-wrapper .se-wrapper-wysiwyg').css({ 'background-color': '#fff;', 'opacity': '0;' });
    //  }
    //  if (this.IsEdit === false) {
    //    $('.sun-editor .se-wrapper .se-wrapper-wysiwyg').css({ 'background-color': '#eee;', 'opacity': '1;' });

    //  }

    //   this.IsEdit? this.initEditor.enabled():this.initEditor.disabled();
    //   this.IsEdit? this.initEditor.toolbar.show(): this.initEditor.toolbar.hide() ;
    this.content = this.labelHtml;

    // $("#displayEditibleCheckboxId").html(this.labelHtml)

    //  var   str=' ';
    //  this.initEditor.insertHTML(str);
    var div = document.querySelectorAll('div[contenteditable="true"]');
    setTimeout(function () {
      //this.initEditor.appendContents("");
      if (div.length > 0) {

      }

    }, 500);
    // var editable = $('#labelHtml').attr('contenteditable');

    // $('#labelHtml').attr('contenteditable', (editable == 'true'?'false':'true'));
  }

  _formId: number;
  async OnUpdateClick() {
    this.IsEdit = !this.IsEdit;
    this.showspinner = false;
    //   if (this.IsEdit === true) {
    //    $('.sun-editor .se-wrapper .se-wrapper-wysiwyg').css({ 'background-color': '#fff;', 'opacity': '0;' });
    //  }
    //  if (this.IsEdit === false) {
    //    $('.sun-editor .se-wrapper .se-wrapper-wysiwyg').css({ 'background-color': '#eee;', 'opacity': '1;' });

    //  }

    //   this.IsEdit? this.initEditor.enabled():this.initEditor.disabled();
    //   this.IsEdit? this.initEditor.toolbar.show(): this.initEditor.toolbar.hide() ;
    this._formId = Number(this.route.snapshot.paramMap.get('DocLibPatientFormID'));
    this.editactions();
    this.labelHtml = this.content;

    if (this._formId > 0) {
      this.labelHtml = $("#editibleCheckboxId").html();
      $("#displayEditibleCheckboxId").html(this.labelHtml);
      await this.SaveConsentforms('');

    }
    $("span").css("pointer-events", "none");
    $('#spanEditDivId').hide();
    $('#editibleCheckbox').show();
    this.labelHtml = $("#editibleCheckboxId").html();
    $("#displayEditibleCheckboxId").html(this.labelHtml);

    //setTimeout(()=>{

    // $('#editibleCheckbox').load(' #editibleCheckbox')
    //alert(this.labelHtml)
    //  document.getElementById("editibleCheckbox").style.display = "block";
    // document.getElementById("spanEditDivId").style.display = "none";

    //this.patientFormId = Number(this.route.snapshot.paramMap.get('DocLibPatientFormID'));
    //alert(this.patientFormId + " :: PatientId")
    // this.onEditMode(this.patientFormId);
    // },2000)

  }
  editactions() {
    if (this.IsEdit === true) {
      $('.sun-editor .se-wrapper .se-wrapper-wysiwyg').css({ 'background-color': '#fff;', 'opacity': '0;' });
    }
    if (this.IsEdit === false) {
      $('.sun-editor .se-wrapper .se-wrapper-wysiwyg').css({ 'background-color': '#eee;', 'opacity': '1;' });

    }

    this.IsEdit ? this.initEditor.enabled() : this.initEditor.disabled();
    this.IsEdit ? this.initEditor.toolbar.show() : this.initEditor.toolbar.hide();



  }
  OnCancelClick() {
    this.IsEdit = !this.IsEdit;
    $("span").css("pointer-events", "none");
    this.editactions();
    this.content = this.labelHtml;
    this.initEditor.setContents(this.labelHtml);
    // this.initEditor.insertHTML(this.labelHtml);
    $("#editibleCheckboxId").html(this.labelHtml);
    //$("#divRefreshId").load(location.href+" #divRefreshId>*","");
    document.getElementById("editibleCheckbox").style.display = "block";
    document.getElementById("spanEditDivId").style.display = "none";

  }

  getContent(innerText) {
    this.content = innerText;
  }

  initEditor: any;
  editorinit() {

    this.initEditor = suneditor.create((document.getElementById('Formseditor') || 'Formseditor'), {
      plugins: plugins,
      height: '400',
      width: '100%',
      fontSize: [8, 9, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48],
      buttonList: [
        ['undo', 'redo', 'font', 'fontSize', 'bold', 'underline', 'italic',
          'removeFormat', 'list', 'outdent', 'indent', 'align',]
      ],
    });
    /*suneditor.create((document.getElementById('Formseditor') || 'Formseditor'), {
   plugins: plugins,
   height: '400',
   width: '100%',
   fontSize: [8, 9, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48],
   buttonList: [
     ['undo', 'redo',
       'font', 'fontSize', 'formatBlock',
       'paragraphStyle',
       'bold', 'underline', 'italic',
       'fontColor', 'hiliteColor',
       'removeFormat',
       'outdent', 'indent',
       'horizontalRule', 'list', 'lineHeight',
       'align',
     'table', *  'align', 'strike', 'textStyle', 'subscript', 'superscript','blockquote','link', 'image', 'video', 'audio',  'math', */ // You must add the 'katex' library at options to use the 'math' plugin.
    /** 'imageGallery',  // You must add the "imageGalleryUrl".
    'fullScreen', 'showBlocks', 'codeView',
    'preview', 'print', 'save', 'template'

  ]
]
});*/
    this.initEditor.disabled();
    this.initEditor.toolbar.hide()
  }
  ngOnInit() {

    document.getElementById("spanEditDivId").style.display = "none";
    this.editorinit();
    try {
      this.EditForms = this.formBuilder.group({
        practiceForm: ['',],
        effectiveDate: ['',],
        exprirationDate: ['',],
        patientId: ['',],
        signoffDateTime: ['',],
        statusForms: ['',],
        description: ['',],
        PatientsignoffDateTime: ['',],
        patientSignature: ['',],
        visitDate: ['',],
        // driverName: [''],
        isActive: [true,],
        NurseId: ['',],
        ProvidersignoffDateTime: ['',],
        NursignoffDateTime: ['',],
        OthName: ['',],
        OthRelation: ['',],
        othInfo: ['',],
        othsignoffDateTime: ['',],
        ClerksignoffDateTime: ['',],
        ProviderID: ['',],
        ClerkId: ['',],
        Formseditor: [''],
      });

      if (CommonComponents.patientId == null || CommonComponents.patientId == undefined || CommonComponents.patientId == 0) {
        this.toastr.error("Please Select Patient");

        this.EditForms.disable();
        //this.router.navigateByUrl('/Appointments');
      }

      //alert(sessionStorage.getItem("appDate"));
      //var visdate=sessionStorage.getItem("appDate");
      if (this.DocLibTargetLocID != Defaults.DocLibraryPatDemographicsID) {
        if (sessionStorage.getItem("appDate") != null && sessionStorage.getItem("appDate") != undefined) {
          this.EditForms.patchValue({
            visitDate: new Date(sessionStorage.getItem("appDate").toString())
          });
        }
      }
      if (this.DocLibTargetLocID == Defaults.DocLibraryCheckinForm) {
        this.headerVisibility = false;
        CommonComponents.demoheaderVisibility = false;
        this.widgetposition = 5;
      }
      this.IsReadytoSignOff = false;
      // if (this.DocLibTargetLocID == Defaults.DocLibraryCheckinForm)
      //   this.widgetposition = 5
      if (this.DocLibTargetLocID == Defaults.DocLibraryVisitNote) {

        //this.activetab=21;//18;
        //  this.activetab=21+(sessionStorage.getItem("pumPRefillVisibility") == "True" ? 1: 0);//18;
        this.activetab = 22;//18;
        if (sessionStorage.getItem("pumPRefillVisibility") != "True") {
          this.activetab = this.activetab - 1;
        }
      }
      if (this.DocLibTargetLocID == Defaults.DocLibraryPatDemographicsID) {
        this.activetab = 9;
        //sessionStorage.removeItem("appId")

      }


      this.getServerTime();//siva
      this.getCurrentVisitDetails();//siva
      this.patientNameById = CommonComponents.patientId;
      this.route.paramMap.subscribe(params => {
        const personId = CommonComponents.patientId;

        if (personId) {
          this.getPeresonalInfo(personId);
        }
      });
      this.EditForms.markAllAsTouched();
      this.EditForms.valueChanges.subscribe((data) => {
        this.logValidationErrors(this.EditForms);
      });
      // this.getAllProviders("Doctor");
      // this.getAllProviders("Nurse");
      // this.getAllProviders("Clerk");
      //this.hide = false;Nurse Clerk Doctor

      this.patientFormId = Number(this.route.snapshot.paramMap.get('DocLibPatientFormID'));
      if (this.patientFormId != null || this.patientFormId != undefined) {
        if (this.patientFormId > 0) {

          this.consentNameMasterDetails = this.allconsentNameMasterDetails;
          this.onEditMode(this.patientFormId);

        }
        else {
          this.patientFormId = 0;
          if (this.allconsentNameMasterDetails != undefined)
            this.consentNameMasterDetails = this.allconsentNameMasterDetails.filter(x => x.Isactive == true);
        }
      }
      this.EditForms.patchValue({
        effectiveDate: this._ServerdateTime,
      });


      // this.removejscssfile("SignaturePadHandler1.js", "js")
      // this.removejscssfile("SigWebTablet1.js", "js")

      // this.removejscssfile("SignaturePadHandler.js", "js")
      // this.removejscssfile("SigWebTablet.js", "js")

      // // this.startSignaturePad();
      // this.startSignaturePad1();
      // //  this.onclickTablet(null);
      // this.onclickTablet1(null, null);
      // ////this.spinner.hide();
    }
    catch (ex) {
      //this.spinner.hide();
      this.showspinner = false;
    }
    finally {
      setTimeout(() => {
        //this.spinner.hide();
      }, 3000);

    }
    this.spanEditiorfunction();

  }

  spanEditiorfunction() {
    var box = document.getElementById('editibleCheckboxId');

    //*** Bold ***/
    document.getElementById('bold').addEventListener('click', function (e) {
      box.focus();
      document.execCommand('bold', false, null);
    });

    //*** Italic ***/
    document.getElementById('italic').addEventListener('click', function (e) {
      alert('called italic event')
      box.focus();
      document.execCommand('italic', false, null);
    });

    //*** underline ***/
    document.getElementById('underline').addEventListener('click', function (e) {
      box.focus(); // make it the active element so the command is applied to it
      //console.log(e);
      document.execCommand('underline', false, null);
    });

    //*** Undo ***/
    document.getElementById('undo').addEventListener('click', function (e) {
      box.focus();
      document.execCommand('undo', false, null);
    });

    //*** Redo ***/
    document.getElementById('redo').addEventListener('click', function (e) {
      box.focus();
      document.execCommand('redo', false, null);
    });

    //*** Font Size ***/
    document.getElementById('FontSize').addEventListener("change", function (e) {
      box.focus();
      document.execCommand('fontSize', false, $("#FontSize").val());
    });

    //*** Font Style ***/
    document.getElementById('FontStyle').addEventListener("change", function (e) {
      box.focus();
      document.execCommand('fontName', false, $("#FontStyle").val());
    });
     
    $('#editibleCheckboxId').on('keyup', function (e) {
      if (e.which == 8) {
        if($("#editibleCheckboxId").html() != null && $("#editibleCheckboxId").html() != undefined && $("#editibleCheckboxId").html() !=""){
          $("#editibleCheckboxId").html($("#editibleCheckboxId").html().replace(/ onclick="onClickDocLibCheckbox(this)""/g, ''))
          $("#editibleCheckboxId").html($("#editibleCheckboxId").html().replace(/type="checkbox"/g, 'type="checkbox" onclick="onClickDocLibCheckbox(this)"'))
        } }
      });
     }


  // This ngAfterContentChecked method used for old  Signature Pad Purpose
  tabletDoneCheckSignatureP: boolean = false;
  tabletDoneCheckSignatureW: boolean = false;
  ngAfterContentChecked(): void {
    if (this.clickButtonType == 'PatientSign') {
      if (document.getElementById("tabletDoneCheckSignatureP").innerHTML == 'true') {
        this.toastr.success('Patient Signature Captured Successfully!')
        this.EnterDefaultDateTime("PatientsignoffDateTime");
        document.getElementById("tabletDoneCheckSignatureP").innerHTML = 'false';
      }
    } else if (this.clickButtonType == 'OtherSign') {
      if (document.getElementById("tabletDoneCheckSignatureW").innerHTML == 'true') {
        this.toastr.success('Witness Signature Captured Successfully!')
        this.EnterDefaultDateTime("othsignoffDateTime");
        document.getElementById("tabletDoneCheckSignatureW").innerHTML = 'false';
      }
    }

  }

  onSelectionChangeLeav(event) {

    // $(event.target).trigger('focus');
    $('#cd').trigger("focus");
    document.body.click();
    //    event.returnValue = false 
  }
  get f() { return this.EditForms.controls; }

  SendEmail() {
    try {

      //this.spinner.show();

      let nurseid = this.signNurseId//(this.EditForms.value.NurseId);
      //nurseid=encodeURIComponent(nurseid);
      nurseid = encodeURIComponent(this.crypto.encryptor(nurseid).toString());

      this._UserManagementService.getUserInfoById(nurseid).subscribe(data => {

      });
      //

      this.FacilityID = Number(sessionStorage.getItem("FacilityId"));
      this.consentMasterService.DocumentLibrary_SendMail(Defaults.DocumentLibrary, this.patientFormId, CommonComponents.patientId, this.ConsentFormName, this.FacilityID).subscribe(
        results => {
          //this.spinner.hide();
          this.result = results;
          this.toastr.success("Mail Sent");
        }, (err: any) => {
          if (err !== null && err !== undefined) {
            if (err.includes('Documents save location not configured'))
              this.toastr.warning('Documents are not configured to this location');
            else
              this.toastr.warning(err);
          }
          console.log(err);
        });
    }
    catch (ex) {
      //this.spinner.hide();
      this.showspinner = false;

    }
    finally {
      setTimeout(() => {
        //this.spinner.hide();
      }, 2000);

    }

  }

  saveToChart() {
    if (CommonComponents != null && CommonComponents != undefined) {
      if (sessionStorage.getItem("LocationId") == null || sessionStorage.getItem("LocationId") == '' || sessionStorage.getItem("LocationId") == undefined) {
        this.sharedService.getLocationsByLoginUser().subscribe(async data => {
          Number(data);
          sessionStorage.setItem("LocationId", data);

          this.callserviceSAVETOCHART();
        });
      }
      else {
        this.callserviceSAVETOCHART();
      }

    }
  }
  callserviceSAVETOCHART() {


    this.progressNotesService.DocumentCategory_NoteReports(Defaults.DocumentLibrary, this.Doctype, this.patientFormId, CommonComponents.patientId, Number(sessionStorage.getItem("LocationId")), CommonComponents.encounterId, sessionStorage.getItem("appId")).subscribe(
      results => {
        this.result = results;
        //alert(this.result);
        if (this.result == "Document already exist") {
          this.toastr.error(this.result);


        }
        else {
          this.toastr.success("Saved to chart");
        }
      }, (err: any) => {
        if (err !== null && err !== undefined) {
          if (err.includes('Documents save location not configured'))
            this.toastr.warning('Documents are not configured to this location');
        }
        console.log(err);
      });

  }
  isProvidersigned: boolean = false;
  // isProvidersigned:boolean=false;
  isNurseSigned: boolean = false;

  isClerkSigned: boolean = false;

  isOtherSigned: boolean = false;

  isPatientSigned: boolean = false;
  ShowReport() {
    //alert(this.patientFormId);
    let reportParamters = new IReportParameters();
    reportParamters.reportUrl = configuration.reportsUrl + "/ConsentFormRpt";//'NEMR/ConsentForms';
    reportParamters.parameters = {
      "EMRConsentFormID": this.patientFormId
    };
    const dialogRef = this.dialog.open(ShowSSRSReportComponent, {
      width: '850px',
      height: '100%',
      data: reportParamters
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  getCurrentVisitDetails() {
    var encounterId = '';
    if (CommonComponents.encounterId == undefined || CommonComponents.encounterId == null)
      encounterId = '';
    else
      encounterId = CommonComponents.encounterId;

    if (encounterId) {
      this.dateservice.getVisitDetails(encounterId).subscribe(data => {

        //this.EditForms.controls['ProviderID'].setValue(data.physician);
        if (data.physician != null && data.physician != undefined && data.physician != "") {
          this.providerNameId = data.physician;
        }
        if (data.physician != null && data.physician != undefined) {
          this.autoCompleteValueBind(data.physician, "ProviderID");
        }
      });
    }
  }

  onSubmit() {
    this.submitted = true;
    if (this.EditForms.invalid) {
      return;
    }
  }

  async getPeresonalInfo(id: number) {
    if (id != null || id != undefined) {
      this.patientformService.getPatientPersonalInfo(id)
        .subscribe(
          (personal: IPatientPersonalInfo) => {
            this.personalInfo = personal;
            if (this.personalInfo.middleName != "")
              this.PatName = this.personalInfo[0].lastName + ', ' + this.personalInfo[0].firstName + ' ' + this.personalInfo[0].middleName + ' ' + this.personalInfo[0].suffix;
            else
              this.PatName = this.personalInfo[0].lastName + ', ' + this.personalInfo[0].firstName + '' + this.personalInfo[0].middleName + ' ' + this.personalInfo[0].suffix;
            this.EditForms.patchValue({
              patientId: this.PatName,    //[this.personalInfo[0].lastName, this.personalInfo[0].firstName, this.personalInfo[0].middleName].filter(Boolean).join(", ") + ' ' + this.personalInfo[0].suffix,
            });

          },
          (err: any) => console.log(err)
        );
    } else {
      this.toastr.warning('Invalid PatientId');
    }

  }
  public providersNurseList: IUserDetails[];
  public providersDocList: IUserDetails[];
  public providersClerkList: IUserDetails[];
  async getAllProviders(role: string) {

    // if(role=="Nurse"){
    // this.sharedService.getAllUsersByRole("Nurse").subscribe(data => {
    //    this.providersNurseList = data;
    //  }); }

    // else if(role=="Doctor"){
    //   this.sharedService.getAllUsersByRole("Doctor").subscribe(data => {
    //     this.providersDocList = data;
    //   }); }
    //   else if(role=="Clerk"){
    //     this.sharedService.getAllUsersByRole("Clerk").subscribe(data => {
    //       this.providersClerkList = data;
    //     });


    // }
    // if (this.DocLibTargetLocID === 91) {
    //   if (role == "Nurse") {
    //     this.sharedService.getAllUsersByRoleWithOutLocId("Nurse").subscribe(data => {
    //       this.providersNurseList = data;
    //     });
    //   }

    //   else if (role == "Doctor") {
    //     this.sharedService.getAllUsersByRoleWithOutLocId("Doctor").subscribe(data => {
    //       this.providersDocList = data;
    //     });
    //   }
    //   else if (role == "Clerk") {
    //     this.sharedService.getAllUsersByRoleWithOutLocId("Clerk").subscribe(data => {
    //       this.providersClerkList = data;
    //     });


    //   }
    // }
    // else {
    if (role == "Nurse") {
      await this.sharedService.getAllUsersByRole("Nurse").subscribe(data => {
        this.providersNurseList = data;
        this.nurseIdfilter();
      });
    }

    else if (role == "Doctor") {
      await this.sharedService.getAllUsersByRole("Doctor").subscribe(data => {
        this.providersDocList = data;
        this.providerNamefilter();
      });
    }
    else if (role == "Clerk") {
      await this.sharedService.getAllUsersByRole("Clerk").subscribe(data => {

        this.providersClerkList = data;
        this.clerkNamefilter();
      });


    }
    // }
  }

  ConsentFormName: string;
  DocDestID: number;
  Expirationdays: number;
  LocationID: number;
  FacilityID: number;
  csvary: string[];
  Signedusers: IDocLibPatientForms_Signatures[];
  isNoSigns: boolean = false;
  onSelectionChange(eventid) {
    // alert('get 1')
    //this.spinner.show();
    //alert('selection change')
    try {
      this.showspinner = true
      // $('#loaderRX').show();
      // $('#spdiv').show();
      if (eventid == 0)
        // return;
        this.Signedusers = null;

      this._htmlstr = "";
      // this.ConsentFormName = event.target.options[event.target.options.selectedIndex].text;event.target.value
      // var practiceFormobj = this.consentNameMasterDetails.filter(x => x.MasterConsentId === Number(event.target.value));
      var practiceFormobj = this.consentNameMasterDetails.filter(x => x.MasterConsentId === Number(eventid));

      // this.SelectedConsentMasterID = event.target.value
      this.SelectedConsentMasterID = eventid;
      //practiceFormobj[0].MasterConsentId;
      //  var consentMasterData=this.consentMasterDetails;
      var consentMasterData: IConsentMasterData_DocLibrary[];

      // this.consentMasterService.getConsentMasterDetails(this.SelectedConsentMasterID)
      let EncID = "";
      if (CommonComponents.encounterId != undefined)
        EncID = CommonComponents.encounterId;
      if (sessionStorage.getItem("patientId") != null || sessionStorage.getItem("patientId") != undefined) {
        CommonComponents.patientId = parseInt(sessionStorage.getItem("patientId"));
      }
      this.consentMasterService.getConsentMasterDetailsData(this.SelectedConsentMasterID, CommonComponents.patientId, EncID, this.DocLibTargetLocID)
        .subscribe(data => {

          consentMasterData = data;
          if (consentMasterData != undefined && consentMasterData != null && consentMasterData.length > 0) {
            this.hide = false;
            this.spanResetdata = consentMasterData[0].ConsentData;
            //var practiceFormName = practiceFormobj[0].ConsentName;
            this.ConsentFormName = consentMasterData[0].ConsentName;
            this.DocDestID = consentMasterData[0].DocDestID
            this.Expirationdays = consentMasterData[0].ExpirationDays;
            //this.LocationID:Number;
            //this.FacilityID:number;
            //fill the Expiration date
            var newdate: Date;
            this.getServerTime();
            var expDayscnt = consentMasterData[0].ExpirationDays;
            // var patientname=this.EditForms.value.patientId;
            if (expDayscnt == null || expDayscnt == 0) {
              //this.EditForms.value.effectiveDate.setValue('');
            }
            else {

              newdate = new Date();
              newdate.setDate(new Date(this.EditForms.controls.effectiveDate.value).getDate() + expDayscnt);
              // newdate =moment(new Date(this.EditForms.controls.effectiveDate.value)).add(expDayscnt,'d');
              //this.MyDateString = moment(new Date(this.form.controls.myDate.value)).format("YYYY/MM/DD").toString();
              //this.EditForms.controls["exprirationDate"].setValue(newdate);

            }
            if (this.personalInfo) {
              let htmlstr = consentMasterData[0].ConsentData;

              this.EditForms.patchValue({
                //  effectiveDate: this._ServerdateTime,
                //exprirationDate: newdate,
                //practiceForm: practiceFormobj[0].MasterConsentId,
                //  patientId: this.personalInfo[0].lastName + ' ' + this.personalInfo[0].firstName + ' ' + this.personalInfo[0].middleName,

                patientId: this.PatName,           //[this.personalInfo[0].lastName, this.personalInfo[0].firstName, this.personalInfo[0].middleName].filter(Boolean).join(", ") + ' ' + this.personalInfo[0].suffix,
                description: this.sanitizer.bypassSecurityTrustHtml(htmlstr),
                //  patientId:patientname,
              });
              $("#displayEditibleCheckboxId").attr("disabled", true);
              // $("#displayEditibleCheckboxId").html(htmlstr) //laxman2
              // alert('Result string :: '+ htmlstr)

              // this.EditForms.patchValue({
              //   description:this.sanitizer.bypassSecurityTrustHtml(htmlstr)
              // })
              this.autoCompleteValueBind(practiceFormobj[0].MasterConsentId, "PracticeForm");


              this.DocLibConsentHtml = htmlstr;


              htmlstr = this.replaceAll(htmlstr, "[[", "");
              htmlstr = this.replaceAll(htmlstr, "]]", "");
              htmlstr = this.replaceAll(htmlstr, ":", ": ");
              htmlstr = this.replaceAll(htmlstr, ",.", ".");
              htmlstr = this.replaceAll(htmlstr, "..", ".");
              htmlstr = this.replaceAll(htmlstr, "<br><br><br>", "<br><br>")
              // htmlstr = this.replaceAll(htmlstr, "?", "&nbsp;");
              // htmlstr = this.replaceAll(htmlstr, `'`, `"`);

              this._htmlstr = htmlstr;
              //radiobutton
               $("#displayEditibleCheckboxId").html(this.labelHtml)
              setTimeout(() => {
                var emptyspans = $("#suneditor_Formseditor").find(".se-wrapper-inner p");
                $.each(emptyspans, function (i, p) {
                  if (p.innerText.trim() == '') {
                    $(p).remove();
                  }
                });
                //var emtyps = emptyspans.filter(function (x: any) { return x.innerText.replace('\ /g') == "" });//.ToArray();//.Select(function (s) { return s }).ToArray();
                //var emtyps = Enumerable.from(emptyspans).where((x: any)=> x.innerText == "" || x.innerText == " " || x.innerText == "&nbsp;&nbsp;" || x.innerText == "  ").select(s => s).toArray();
                var t = emptyspans;
              }, 500);
              if (this.patientFormId != null || this.patientFormId != undefined) {
                if (this.patientFormId > 0) { } else {
                  this.labelHtml = this._htmlstr;


                  this.initEditor.setContents('');
                  this.initEditor.setContents(this.labelHtml);
                  //alert('1121 :: ' + this.labelHtml)

                  //       let allData = this.labelHtml.split("|_|");//consentMasterData[0].FormData.split("|_|");
                  // let htmlstr = allData[0];//consentMasterData[0].FormData //.ConsentData;
                  // $("#chkIds").val(allData[1]);
                  // $(allData[1]).each(function (item) {
                  //       //$(this).css("background-color", "pink");
                  //       //alert()
                  //   });

                  // allData[1].each(function(item, i){
                  //   alert('call ')
                  //   $("'" + item + "'").on("click", function(){
                  //          if($(this).is("checked"))
                  //   {
                  //       $(this).attr("onclick", "onClickDocLibCheckbox(this)");
                  //   }
                  //   });
                  // });
                  // $('"' + allData[1] + '"').on("click", function(){
                  //   if($(this).is("checked"))
                  //   {
                  //       $(this).attr("onclick", "onClickDocLibCheckbox(this)");
                  //   }
                  // });
                  // alert('this.spanResetdata :: '+ this.spanResetdata);
                  $("#editibleCheckboxId").html(this.labelHtml);
                  $("#displayEditibleCheckboxId").html(this.labelHtml);
                  $("span").css("pointer-events", "none");



                  this.initEditor.disabled();
                  this.initEditor.toolbar.hide();
                  this.editactions();
                  this.content = this.labelHtml;
                  // this.sanitizer.bypassSecurityTrustHtml(htmlstr);
                }
              }
            }


            if (this.patientFormId != null || this.patientFormId != undefined) {
              if (this.patientFormId > 0) { } else {
                this.csvary = consentMasterData[0].SelectedSignatureList.split(",");

                this.CurentSigntureBY = Number(this.csvary[0]);
                if (this.csvary[0] == "") {
                  this.isNoSigns = true;
                  this.IsPatientSignature = false;
                  this.ISNurseSignature = false;
                  this.ISProviderSignature = false;
                  this.IsClerkSignature = false;
                  this.ISOthersSignature = false;
                } else {
                  this.IsPatientSignature = this.csvary.some(e => e == '1');
                  this.ISNurseSignature = this.csvary.some(e => e == '2');
                  this.ISProviderSignature = this.csvary.some(e => e == '3');
                  this.IsClerkSignature = this.csvary.some(e => e == '4');
                  this.ISOthersSignature = this.csvary.some(e => e == '5');

                  this.PatientdivOrderid = this.csvary.findIndex(x => x === "1");
                  this.NursedivOrderid = this.csvary.findIndex(x => x === "2");
                  this.ProviderdivOrderid == this.csvary.findIndex(x => x === "3");
                  this.ClerkdivOrderid = this.csvary.findIndex(x => x === "4");
                  this.OtherdivOrderid = this.csvary.findIndex(x => x === "5");

                  this.isNoSigns = false;
                }

              }
            }
            this.enableReadyToSignOff();
            //fill the description data consentMasterData[0].ConsentData

          }
          this.showspinner = false;
          //this.spinner.hide();

          // $('#loaderRX').hide();
          // $('#spdiv').hide();
        },
          error => {
            this.showspinner = false;
            //this.spinner.hide();
            // $('#loaderRX').hide();
            // $('#spdiv').hide();
          });
      // $('#loaderRX').hide();
      // $('#spdiv').hide();
      //this.spinner.hide();
    } catch (ex) {
      this.showspinner = false;
      //this.spinner.hide();
      //  $('#loaderRX').hide();
      //  $('#spdiv').hide();
    }
    finally {
      //this.spinner.hide();

    }
  }
  getMyStyles(val: string) {

    if (this.csvary == undefined) { return; }
    if (val == 'P') {
      this.PatientdivOrderid = this.csvary.findIndex(x => x === "1");

    }
    else if (val == 'O') {
      this.OtherdivOrderid = this.csvary.findIndex(x => x === "5");

    } else if (val == 'N') {
      this.NursedivOrderid = this.csvary.findIndex(x => x === "2");


    }
    else if (val == 'D') {
      this.ProviderdivOrderid = this.csvary.findIndex(x => x === "3");


    }
    else if (val == 'C') {
      this.ClerkdivOrderid = this.csvary.findIndex(x => x === "3");


    }


  }
  IsProviderDisable: boolean = false;
  spanResetdata: any;
  onEditMode(PatientFormID) {
    try {
      //alert('get 2')
      //this.spinner.show();
      this._htmlstr = "";

      var consentMasterData: IDocLibPatientForms[];
      //this.SelectedConsentMasterID= event.target.value
      this.consentMasterService.getEMRConsentDetails_ConsentID(PatientFormID)
        .subscribe(data => {
          consentMasterData = data;
          if (consentMasterData != undefined && consentMasterData != null && consentMasterData.length > 0) {
            if (consentMasterData[0].SignatureBY) {
              this.csvary = consentMasterData[0].SignatureBY.split(",");
              this.IsPatientSignature = this.csvary.some(e => e == '1');
              this.ISNurseSignature = this.csvary.some(e => e == '2');
              this.ISProviderSignature = this.csvary.some(e => e == '3');
              this.IsClerkSignature = this.csvary.some(e => e == '4');
              this.ISOthersSignature = this.csvary.some(e => e == '5');


              this.PatientdivOrderid = this.csvary.findIndex(x => x === "1");
              this.NursedivOrderid = this.csvary.findIndex(x => x === "2");
              this.ProviderdivOrderid == this.csvary.findIndex(x => x === "3");
              this.ClerkdivOrderid = this.csvary.findIndex(x => x === "4");
              this.OtherdivOrderid = this.csvary.findIndex(x => x === "5");
              this.isNoSigns = false;
            } else {
              this.isNoSigns = true;
            }


            this.hide = false;
            //var practiceFormName = consentMasterData[0].ConsentName;//practiceFormobj[0].ConsentName;
            this.ConsentFormName = consentMasterData[0].FormName;
            this.DocDestID = consentMasterData[0].DocDestID
            this.Expirationdays = consentMasterData[0].ExpirationDays;
            this.providerNameId = consentMasterData[0].ProviderId;
            this.IsReadytoSignOff = consentMasterData[0].IsReadyToSignoff;
            // let allData = consentMasterData[0].FormData.split("|_|");
            let htmlstr = consentMasterData[0].FormData //.ConsentData;
            // $("#chkIds").val(allData[1]);
            this.effectdate = consentMasterData[0].FormData
            // htmlstr = this.replaceAll(htmlstr, "?", "");
            this.DocLibConsentHtml = htmlstr;

            this._htmlstr = htmlstr;
            // this.labelHtml = this.sanitizer.bypassSecurityTrustHtml(htmlstr);
            this.labelHtml = this._htmlstr;
            //this.spanResetdata= this.labelHtml;
            this.initEditor.setContents('');
            this.initEditor.setContents(this.labelHtml);
            $("#displayEditibleCheckboxId").html(this.labelHtml)
            // alert(this.labelHtml)
            $("#editibleCheckboxId").html(this.labelHtml);
            $("span").css("pointer-events", "none");
            this.editactions();
            this.content = this.labelHtml;

            this.EditForms.controls["isActive"].setValue(consentMasterData[0].IsActive);

            this.IsReadytoSignOff = consentMasterData[0].IsReadyToSignoff
            if (this.IsReadytoSignOff == true) {
              this.IsProviderDisable = true;
            } else {
              this.IsProviderDisable = false;
            }
            this.EditForms.patchValue({
              effectiveDate: consentMasterData[0].ValidFrom,
              visitDate: consentMasterData[0].VisitDate,
              exprirationDate: consentMasterData[0].ValidUpto,
              //practiceForm: consentMasterData[0].FormID,
              //patientId: CommonComponents.patientName,
              // patientId: [this.personalInfo[0].lastName, this.personalInfo[0].firstName, this.personalInfo[0].middleName].filter(Boolean).join(", ")+' '+this.personalInfo[0].suffix,

              isActive: consentMasterData[0].IsActive,
              //this.DocLibPersonalInfo[0].LastName + ' ' + this.DocLibPersonalInfo[0].FirstName + ' ' + this.DocLibPersonalInfo[0].MiddleName,
              description: this.sanitizer.bypassSecurityTrustHtml(htmlstr),
              Formseditor: this.labelHtml,
              //  patientId:patientname,
            });
            //laxman-3
            //   $("#displayEditibleCheckboxId").html(this.labelHtml)
               $("#editibleCheckboxId").html(this.labelHtml);
            //  alert('1295')
            //   $("span").css("pointer-events", "none");

            var obj1 = new IConsentNameMasterData_DocLibAll;

            obj1.ConsentName = consentMasterData[0].FormName
            obj1.Isactive = true
            obj1.MasterConsentId = consentMasterData[0].FormID
              ;
            if (!this.consentNameMasterDetails.some(x => x.MasterConsentId == obj1.MasterConsentId && x.ConsentName == obj1.ConsentName)) {    // this.getConsentDetails_Targetloc(this.DocLibTargetLocID,obj);
              ;
              this.IsMasterTemplateExist = false
              var obj: IConsentNameMasterData_DocLibAll[] = [];
              obj.push(obj1)
              this.allconsentNameMasterDetails = obj

              this.consentNameMasterDetails = obj
            }

            this.autoCompleteValueBind(consentMasterData[0].FormID, "PracticeForm");
            this.SelectedConsentMasterID = consentMasterData[0].FormID;
            this.EditForms.controls['practiceForm'].disable();
            // this.practiceForm=this.SelectedConsentMasterID

            ;
            this.consentMasterService.GetEMRConsentSignedList(PatientFormID)
              .subscribe(sdata => {
                this.Signedusers = sdata;
                var str = consentMasterData[0].SignatureList;
                //str = str.slice(1, str.length - 1);
                var Jsonstrarry = JSON.parse(str);//str.split(",");
                if (this.Signedusers != undefined || this.Signedusers != null || this.Signedusers.length > 0) {




                  //Patient	1
                  let filtereddata = this.Signedusers.filter(SUsers => SUsers.SignatureID === "1");
                  if (filtereddata.length > 0) {
                    this.EditForms.patchValue({ PatientsignoffDateTime: formatDate(filtereddata[0].signatureOn, 'MM-dd-yyyy hh:mm:ss a', 'en-US'), });
                    this.signaturePad.fromDataURL('data:image/png;base64,' + filtereddata[0].Signature);
                    var canvas = document.getElementById('cnv') as HTMLCanvasElement;
                    var ctx = canvas.getContext("2d");
                    var image = new Image();
                    image.onload = function () {
                      ctx.drawImage(image, 0, 0);
                    };
                    image.src = "data:image/png;base64," + filtereddata[0].Signature;
                    this.isPatientSigned = true;

                    //*****  */

                    //   setTimeout(() => {

                    //     this.signaturePad.fromDataURL('data:image/png;base64,' + filtereddata[0].Signature);
                    //     var canvas = document.getElementById('cnv') as HTMLCanvasElement;
                    //     var ctx = canvas.getContext("2d");
                    //     //  this.medAdmTime1.nativeElement.focus();
                    //     var image = new Image();

                    //     image.onload = function () {
                    //       ctx.drawImage(image, 111, 300);
                    //     };

                    //     image.src = "data:image/png;base64," + filtereddata[0].Signature;
                    //     this.isPatientSigned = true;
                    //   }, 500);
                  } else {
                    try {
                      var Tempdata = Jsonstrarry.filter(SUsers => SUsers.SignatureID === "1");
                      if (Tempdata.length > 0) {

                        this.EditForms.patchValue({
                          PatientsignoffDateTime: Tempdata[0].signoffdate,

                        });


                      }
                    } catch (ex) { }
                  }
                  //Nurse	2


                  filtereddata = this.Signedusers.filter(SUsers => SUsers.SignatureID === "2");
                  if (filtereddata.length > 0) {
                    this.EditForms.patchValue({
                      NursignoffDateTime: formatDate(filtereddata[0].signatureOn, 'MM-dd-yyyy hh:mm:ss a', 'en-US'),
                      // NurseId: filtereddata[0].SignatureBy,
                    });
                    this.signNurseId = filtereddata[0].SignatureBy
                    this.autoCompleteValueBind(filtereddata[0].SignatureBy, "NurseId")
                    //this.signaturePad.fromDataURL('data:image/png;base64,' + filtereddata[0].Signature);
                    this.isNurseSigned = true;
                  }
                  else {
                    try {

                      var Tempdata = Jsonstrarry.filter(SUsers => SUsers.SignatureID === "2");
                      if (Tempdata.length > 0) {

                        this.EditForms.patchValue({
                          NursignoffDateTime: Tempdata[0].signoffdate,

                        });
                        this.signNurseId = Tempdata[0].UserName;
                        this.autoCompleteValueBind(this.signNurseId, "NurseId")

                      }
                    } catch (ex) { }
                  }

                  //Provider	3

                  filtereddata = this.Signedusers.filter(SUsers => SUsers.SignatureID === "3");
                  if (filtereddata.length > 0) {
                    this.EditForms.patchValue({
                      ProvidersignoffDateTime: formatDate(filtereddata[0].signatureOn, 'MM-dd-yyyy hh:mm:ss a', 'en-US'),
                      //ProviderID: filtereddata[0].SignatureBy,
                    });
                    this.providerNameId = filtereddata[0].SignatureBy;
                    this.autoCompleteValueBind(filtereddata[0].SignatureBy, "ProviderID");
                    //this.signaturePad.fromDataURL('data:image/png;base64,' + filtereddata[0].Signature);
                    this.isProvidersigned = true;
                  }
                  else {
                    try {
                      // if (strarry.length > 1) {
                      //   // this.EditForms.patchValue({
                      //   //   ProviderID: strarry[1]
                      //   // })
                      //   this.providerNameId = strarry[1]
                      //   this.autoCompleteValueBind(strarry[1], "ProviderID")

                      //}
                      var Tempdata = Jsonstrarry.filter(SUsers => SUsers.SignatureID === "3");
                      if (Tempdata.length > 0) {

                        this.EditForms.patchValue({
                          ProvidersignoffDateTime: Tempdata[0].signoffdate,

                        });
                        this.providerNameId = Tempdata[0].UserName;
                        this.autoCompleteValueBind(this.providerNameId, "ProviderID")

                      }
                    } catch (ex) { }
                  }


                  //Clerk	4
                  filtereddata = this.Signedusers.filter(SUsers => SUsers.SignatureID === "4");

                  if (filtereddata.length > 0) {
                    this.EditForms.patchValue({
                      ClerksignoffDateTime: formatDate(filtereddata[0].signatureOn, 'MM-dd-yyyy hh:mm:ss a', 'en-US'),
                      //ClerkId: filtereddata[0].SignatureBy,
                    });
                    //this.autoCompleteValueBind(filtereddata[0].SignatureBy, "ClerkId")
                    this.clerkNameId = filtereddata[0].SignatureBy;
                    this.autoCompleteValueBind(filtereddata[0].SignatureBy, "ClerkId")
                    //this.EditForms.controls.ClerkId.setValue(filtereddata[0].SignatureBy);
                    //this.signaturePad.fromDataURL('data:image/png;base64,' + filtereddata[0].Signature);
                    this.isClerkSigned = true;
                  }
                  else {
                    try {
                      // if (strarry.length > 2) {
                      //   // this.EditForms.patchValue({
                      //   //   ClerkId: strarry[2]
                      //   // })
                      //   this.clerkNameId = strarry[2]
                      //   this.autoCompleteValueBind(strarry[2], "ClerkId")
                      // }
                      var Tempdata = Jsonstrarry.filter(SUsers => SUsers.SignatureID === "4");
                      if (Tempdata.length > 0) {

                        this.EditForms.patchValue({
                          ClerksignoffDateTime: Tempdata[0].signoffdate,

                        });
                        this.clerkNameId = Tempdata[0].UserName;
                        this.autoCompleteValueBind(this.clerkNameId, "ClerkId")

                      }
                    } catch (ex) { }
                  }
                  //Witness	5
                  filtereddata = this.Signedusers.filter(SUsers => SUsers.SignatureID === "5");

                  if (filtereddata.length > 0) {
                    this.EditForms.patchValue({
                      othsignoffDateTime: formatDate(filtereddata[0].signatureOn, 'MM-dd-yyyy hh:mm:ss a', 'en-US'),
                      OthName: filtereddata[0].SignatureBy,
                      OthRelation: filtereddata[0].SignatureRole,
                      othInfo: filtereddata[0].OtherInfo

                    });
                    this.signaturePad2.fromDataURL('data:image/png;base64,' + filtereddata[0].Signature);
                    var canvas1 = document.getElementById('cnv1') as HTMLCanvasElement;
                    var ctx1 = canvas1.getContext("2d");
                    var image1 = new Image();
                    image1.onload = function () {
                      ctx1.drawImage(image1, 0, 0);
                    };
                    image1.src = "data:image/png;base64," + filtereddata[0].Signature;
                    this.isOtherSigned = true;
                    //this.signaturePad.fromDataURL('data:image/png;base64,' + filtereddata[0].Signature);

                  }
                  else {
                    // if (strarry.length > 3) {
                    //   var othary = strarry[3].split(':');
                    //   this.EditForms.patchValue({
                    //     OthName: othary[0],
                    //     OthRelation: othary[1],
                    //   })
                    // }
                    try {
                      var Tempdata = Jsonstrarry.filter(SUsers => SUsers.SignatureID === "5");
                      if (Tempdata.length > 0) {

                        this.EditForms.patchValue({
                          othsignoffDateTime: Tempdata[0].signoffdate,
                          OthName: Tempdata[0].UserName,
                          OthRelation: Tempdata[0].Relation,
                          othInfo: Tempdata[0].otherinfo,
                        });


                      }
                    } catch (ex) { }
                  }
                  this.enableReadyToSignOff();





                }
              });

            this.EditForms.patchValue({
              //patientId: [this.personalInfo[0].lastName, this.personalInfo[0].firstName, this.personalInfo[0].middleName].filter(Boolean).join(", ") + ' ' + this.personalInfo[0].suffix,
            });


          }
        });

    }

    catch (ex) { this.showspinner = false;  }
    finally {
      setTimeout(() => {
        //this.spinner.hide();
      }, 1000);
    }
  }
  IsMasterTemplateExist: boolean = true;
  isProvidersignaureenabled() {

    if (!this.isNurseSigned) {


      if (this.ISNurseSignature) {


      }
      //return false;
    }


  }

  IsAllSignsareCompleted() {
    if (this.EditForms.controls['practiceForm'] == undefined || this.EditForms.controls['practiceForm'].value == '') {
      // this.toastr.error("Please Select Practice form");
      return false;

    }

    if (this.SelectedConsentMasterID == 0) {
      return false;

    }
    if (!this.isNurseSigned) {
      if (this.ISNurseSignature)
        return false;
    }
    if (!this.isPatientSigned) {
      if (this.IsPatientSignature)
        return false;
    }
    if (!this.isProvidersigned) {
      if (this.ISProviderSignature)
        return false;
    }
    if (!this.isOtherSigned) {
      if (this.ISOthersSignature)
        return false;
    }
    if (!this.isClerkSigned) {
      if (this.IsClerkSignature)
        return false;
    }

    if (this.patientFormId == 0) {
      return false;
    }

    if (this.isNoSigns == true)
      return false;

    this.IsEdit = false;
    this.editactions()
    return true;
  }
  readyToSignOffClick() {
    if (this.EditForms.value.ProviderID == "" || this.EditForms.value.ProviderID == undefined) {
      this.toastr.error("Please select Provider Name");
      return false;
    }
    if (sessionStorage.getItem("PatBoardDate") != null && sessionStorage.getItem("PatBoardDate") != undefined) {
      if (this.Doctype != "Forms (Demographics)") {
        if (sessionStorage.getItem("displayappDate") != 'null' && sessionStorage.getItem("displayappDate") != null && sessionStorage.getItem("displayappDate") != undefined) {
          this.sessionvisitdate = new Date(formatDate(sessionStorage.getItem("displayappDate"), 'MM-dd-yyyy', 'en-US'));
        } else {
          if (sessionStorage.getItem("displayappDate") != "null" && sessionStorage.getItem("displayappDate") != null) {
            this.sessionvisitdate = new Date(formatDate(sessionStorage.getItem("displayappDate"), 'MM-dd-yyyy', 'en-US'));
          } else {
            this.sessionvisitdate = new Date(formatDate(sessionStorage.getItem("PatBoardDate"), 'MM-dd-yyyy', 'en-US'));
          }
        }

        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();
        var todaydate = mm + '-' + dd + '-' + yyyy;
        let currentdate = new Date(formatDate(this.currentlocationdate, 'MM-dd-yyyy', 'en-US'));
        //let currentdate = new Date(formatDate(this._ServerdateTime, 'MM-dd-yyyy', 'en-US'));

        if (this.sessionvisitdate > currentdate) {
          this.toastr.error('You cannot sign-off the form for future Visit Date');
          return;
        }
      }


    }
  /*  if(this.EditForms.controls['ClerksignoffDateTime'] ==undefined || this.EditForms.controls['ClerksignoffDateTime'].value=='')
    {
      this.toastr.error("Nurse Sign OFF is Mandatory");
      return ;
    }
    */     this.IsReadytoSignOff = true;
    this.savePatientForm('');

  }

  Isready2signoff: boolean = false;
  public currentlocationdate: string;
  enableReadyToSignOff() {//siva

    let isButtonEnable = true;

    /* if(this.ISProviderSignature==true && this.ISNurseSignature==true
       && (this.EditForms.controls["NursignoffDateTime"].value ==null
       || this.EditForms.controls["NursignoffDateTime"].value =="" ) )
     isButtonEnable=false;
 */

    if (this.ISProviderSignature == true && this.ISNurseSignature == false && this.IsClerkSignature == false && this.IsPatientSignature == false && this.ISOthersSignature == false) {
      //isButtonEnable =true;
      if (this.IsReadytoSignOff) {//button Ready to sign off Already clicked

        isButtonEnable = false;
      }
    }
    //patient signature required and any other signature required
    else if (this.ISProviderSignature == true && (this.ISNurseSignature || this.IsClerkSignature || this.IsPatientSignature || this.ISOthersSignature)) {
      //ready to signoff button visible true
      if (this.ISNurseSignature == true) {
        // if (this.EditForms.controls["NursignoffDateTime"].value == null || this.EditForms.controls["NursignoffDateTime"].value == "")
        if (!this.isNurseSigned)
          isButtonEnable = false;
      }
      if (this.IsPatientSignature == true) {
        // if (this.EditForms.controls["PatientsignoffDateTime"].value == null || this.EditForms.controls["PatientsignoffDateTime"].value == "")
        if (!this.isPatientSigned)
          isButtonEnable = false;
      }
      if (this.IsClerkSignature == true) {
        //if (this.EditForms.controls["ClerksignoffDateTime"].value == null || this.EditForms.controls["ClerksignoffDateTime"].value == "")
        if (!this.isClerkSigned)
          isButtonEnable = false;
      }
      if (this.ISOthersSignature == true) {
        //if (this.EditForms.controls["othsignoffDateTime"].value == null || this.EditForms.controls["othsignoffDateTime"].value == "")
        if (!this.isOtherSigned)
          isButtonEnable = false;
      }

      //if (this.EditForms.controls["ProvidersignoffDateTime"].value != null && this.EditForms.controls["ProvidersignoffDateTime"].value != "") {//already provider signed off disable that button
      if (this.isProvidersigned) {
        isButtonEnable = false;


      }

      if (this.IsReadytoSignOff) {//button Ready to sign off Already clicked

        isButtonEnable = false;
      }


      //isButtonEnable=true;

    }

    else {

      //visible false button Ready to sign off
      isButtonEnable = false;

    }
    this.Isready2signoff = isButtonEnable;
    return isButtonEnable;

  }//siva
  enableSendEmailandSaveChart() {
    let isButtonEnable = true;
    if (this.ISProviderSignature == true && !this.isProvidersigned) {
      // (this.EditForms.controls["ProvidersignoffDateTime"].value == null
      //   || this.EditForms.controls["ProvidersignoffDateTime"].value == ""))
      isButtonEnable = false;//!this.IsAllSignsareCompleted();//this.isProvidersigned;// false;
    } else if (this.ISNurseSignature == true && !this.isNurseSigned) {
      // (this.EditForms.controls["NursignoffDateTime"].value == null ||
      //   this.EditForms.controls["NursignoffDateTime"].value == ""))
      isButtonEnable = false; // !(this.IsAllSignsareCompleted() || this.isNurseSigned);//this.isNurseSigned ; //false

    }
    return isButtonEnable;

  }
  kreplaceAll(str, find, replace) {
    return str.replace(new RegExp(find, 'g'), replace);
  }
  replaceAll(target, search, replacement) {
    //  var target = this;
    return target.split(search).join(replacement);
  };
  getSystem() {

    if (sessionStorage.getItem("encounterid") != null || sessionStorage.getItem("encounterid") != undefined) {
      CommonComponents.encounterId = sessionStorage.getItem("encounterid");
    }
    if (sessionStorage.getItem("patientId") != null || sessionStorage.getItem("patientId") != undefined) {
      CommonComponents.patientId = parseInt(sessionStorage.getItem("patientId"));
    }
    // if (sessionStorage.getItem("demoheaderVisibility") != null || sessionStorage.getItem("demoheaderVisibility") != undefined) {
    //   CommonComponents.demoheaderVisibility = Boolean(sessionStorage.getItem("demoheaderVisibility"));
    // }
  }

  logValidationErrors(group: FormGroup = this.EditForms): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = '';
        if (abstractControl && !abstractControl.valid
          && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }
      }
    });
  }

  drawComplete(ctrl: string, Signaturerole) {

    //if(this.IsvalidConsentform(Signaturerole)){

    //var datetimesrv=this._ServerdateTime;// this.getdatetime(ctrl);
    // datetimesrv=formatDate(datetimesrv, 'MM-dd-yyyy hh:mm:ss a', 'en-US');
    if (ctrl == 'PatientsignoffDateTime') {
      if (this.EditForms.controls[ctrl].value == null || this.EditForms.controls[ctrl].value == "") {
        this.getdatetime(ctrl);
      }
    }
    else if (ctrl == 'othsignoffDateTime') {
      if (this.EditForms.controls[ctrl].value == null || this.EditForms.controls[ctrl].value == "") {
        this.getdatetime(ctrl);
      }
    }
  }

  Isvalidform() {


    if (this.EditForms.controls['practiceForm'] == undefined || this.EditForms.controls['practiceForm'].value == '') {
      this.toastr.error("Please Select Practice form");
      return false;
    }

    if (this.SelectedConsentMasterID == 0) {
      this.toastr.error("Please Select Practice form");
      return false;
    }




    var patid = CommonComponents.patientId;
    if (patid == null || patid == 0) {
      this.toastr.error("Invalid Patient , Please select the Patient");
      return false;
    }
    return true;
  }

  IsvalidConsentform(signaturrole) {
    if (signaturrole == 'Patient') {
      if (this.EditForms.controls['patientId'].value == "") {
        this.toastr.error("Invalid Patient Name");
        return false;
      }
      else {
        let thisSignature = this.signaturePad.toDataURL();
        if (this.signaturePad.isEmpty() || thisSignature == "" || thisSignature == 'undefined') {
          this.toastr.error("Invalid Patient Signature");
          return false;
        }
      }
    }
    else if (signaturrole == 'Others') {
      if (this.IsvalidConsentform('Patient')) {
        if (this.EditForms.controls['OthName'].value == "") {
          this.toastr.error("Please enter Witness Name");
          return false;
        }
        else if (this.EditForms.controls['OthRelation'].value == "") {
          this.toastr.error("Please Enter Relation Name");
          return false;
        }
        else {
          let thisSignature = this.signaturePad2.toDataURL();
          if (this.signaturePad2.isEmpty() || thisSignature == "" || thisSignature == 'undefined') {
            this.toastr.error("Invalid Witness Signature");
            return false;
          }
        } //else

      }//Isvalid Patient

    }
    else if (signaturrole == 'Nurse') {
      if (this.EditForms.value.NurseId == "" || this.EditForms.value.NurseId == undefined) {
        this.toastr.error("Please select Nurse Name");
        return false;
      }
    }
    else if (signaturrole == 'Provider') {
      if (this.EditForms.value.ProviderID == "" || this.EditForms.value.ProviderID == undefined) {
        this.toastr.error("Please select Provider Name");
        return false;
      }
    }
    else if (signaturrole == 'Clerk') {
      if (this.EditForms.value.ClerkId == "" || this.EditForms.value.ClerkId == undefined) {
        this.toastr.error("Please select Clerk Name");
        return false;
      }
    }
    return true;
  }

  public effectdate: string;
  getServerTime() {
    this.dateservice.getservercurrentdate().subscribe(result => {
      this._ServerdateTime = formatDate(result, 'MM-dd-yyyy hh:mm:ss a', 'en-US');
      if (this.patientFormId != null || this.patientFormId != undefined || this.patientFormId == 0) {
        if (this.effectdate == "" || this.effectdate == null || this.effectdate == undefined) {
          this.EditForms.controls["effectiveDate"].setValue(result);
        }

      }
      // this.EditForms.controls["visitDate"].setValue(this.datepipe.transform(this._ServerdateTime,"MM/dd/yyyy"))

    });
  }

  getdatetime(ctrl) {

    var today = new Date();
    var datetimeForSign = "";
    // datetimeForSign = formatDate(today, 'MM-dd-yyyy hh:mm:ss a', 'en-US', 'locale');
    // this.EditForms.controls[frmControl].setValue(datetimeForSign);
    this.dateservice.getservercurrentdate().subscribe(async result => {
      await result;
      datetimeForSign = formatDate(result, 'MM-dd-yyyy hh:mm:ss a', 'en-US');
      if (ctrl == 'PatientsignoffDateTime') {
        this.EditForms.patchValue({ PatientsignoffDateTime: datetimeForSign, });
        // this.savePatientForm('Patient');
      }
      else if (ctrl == 'othsignoffDateTime') {//alert(datetimesrv);
        this.EditForms.patchValue({ othsignoffDateTime: datetimeForSign, });
        //  this.savePatientForm('Witness');
      }
    });
    return datetimeForSign;
  }

  nurseSelectionChange() {
    //alert(this.EditForms.value.NurseId);

  }
  sessionvisitdate: Date;
  openDialog(UserRole, datetimectrlname): void {
    if (sessionStorage.getItem("PatBoardDate") != null && sessionStorage.getItem("PatBoardDate") != undefined) {
      if (sessionStorage.getItem("displayappDate") != 'null' && sessionStorage.getItem("displayappDate") != null && sessionStorage.getItem("displayappDate") != undefined) {
        this.sessionvisitdate = new Date(formatDate(sessionStorage.getItem("displayappDate"), 'MM-dd-yyyy', 'en-US'));
      }
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();
      var todaydate = mm + '-' + dd + '-' + yyyy;
      let currentdate = new Date(formatDate(this.currentlocationdate, 'MM-dd-yyyy', 'en-US'));
      if (this.sessionvisitdate > currentdate) {
        this.toastr.error('You cannot sign-off the form for future Visit Date');
        return;
      }
    }
    // alert(this.EditForms.value.NurseId);
    var _ID
    var datetimectrlval = this.EditForms.controls[datetimectrlname].value.toString()
    if (UserRole == "Nurse") {
      _ID = this.signNurseId//this.EditForms.value.NurseId;

    } else if (UserRole == "Provider") {
      _ID = this.providerNameId//this.EditForms.value.ProviderID;


    } else if (UserRole == "Clerk") {
      _ID = this.clerkNameId//this.EditForms.value.ClerkId;

    }
    //if (this.EditForms.value.NurseId == "" || this.EditForms.value.NurseId == undefined) {
    if (_ID == "" || _ID == undefined || _ID == "0") {
      this.toastr.error("Please select " + UserRole + " Name");
      return;
    }
    else {
      if (datetimectrlval != "") {
        if (!this.validatetime(datetimectrlval, UserRole))
          return;
      }
      //  alert("selected UserID"+_ID+";  "+"Login ID"+sessionStorage.getItem("userId"));
      var SesUserID = sessionStorage.getItem("userId");
      if (SesUserID == null || SesUserID == undefined)
        SesUserID = "";

      if (UserRole == "Provider" && _ID == sessionStorage.getItem("userId")) {
        //if userrole is provider and loged with same user signoff automatically
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
          width: '400px',
          height: '160px',
          data: { headerText: "Are you sure, you want to Sign Off this report?" }
        });

        dialogRef.afterClosed().subscribe(result => {

          if (result == true) {
            this.progressNotesService.userPassingSignatureById(encodeURIComponent(_ID)).subscribe(data => {
              // this.signaturePad.clear();
              if (data != null && data != undefined) {
                if (data && data.signatureSizeImage && data.signatureSizeImage != undefined) {
                  //save code
                  //      this.getProviderSignature(this.EditForms, result, UserRole, datetimectrlname, _ID);
                  this.ProviderSignoff_Login(this.EditForms, UserRole, datetimectrlname);
                }
                else {
                  // this.toastr.error( "Invalid Code or Signature not Available");
                  //this.IsCodeEnteredPhysician = false;
                  if (JSON.stringify(data).search("Invalid") == -1)
                    this.toastr.error("Invalid Code or Signature not Available");
                  else if (JSON.stringify(data).search("0 more") == -1)
                    this.toastr.error(JSON.stringify(data));
                  else
                    this.toastr.error("Your sign access locked.Please contact Administrator")
                }
                if (UserRole == "Provider") {
                  this.IsProviderSignOff = true;
                }
              }
              else {
                // this.IsCodeEnteredPhysician = false;
                this.toastr.error("Your sign access locked.Please contact Administrator")
              }
            });
            //});      
          }

        });
      }
      else {
        // if (this.isImportantInstSignature == true) {
        // if (true) {
        const dialogRef = this.dialog.open(InputDialogComponent, {
          width: '350px',
          height: '160px',
          data: { headerText: 'Please Enter the Security Code', inputValue: '', inputType: 'pass' }
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result.trim() == "") {
            this.toastr.error("Security Code must be in numbers");
            this.openDialog(UserRole, datetimectrlname);
            return;
          }
          if (result && result != undefined) {

            //   this.callSave = false;
            // this.impSignOff = true;
            if (isNumeric(result)) {
              if (result.toString().includes(".") == true) {
                this.toastr.error("Security Code must be in numbers");
                this.openDialog(UserRole, datetimectrlname);

              }
              else {
                if (true) {
                  ;
                  this.progressNotesService.userPassingSignatureById(encodeURIComponent(_ID)).subscribe(data => {
                    // this.signaturePad.clear();
                    if (data != null && data != undefined) {
                      if (data && data.signatureSizeImage && data.signatureSizeImage != undefined) {
                        //save code
                        this.getProviderSignature(this.EditForms, result, UserRole, datetimectrlname, _ID);
                      }
                      else {
                        // this.toastr.error( "Invalid Code or Signature not Available");
                        //this.IsCodeEnteredPhysician = false;
                        if (data == "Access Locked") {
                          this.toastr.error("Your passcode locked.Please contact Administrator.")
                        } else {
                          if (JSON.stringify(data).search("Invalid") == -1)
                            this.toastr.error("Invalid Code or Signature not Available");
                          else if (JSON.stringify(data).search("0 more") == -1)
                            this.toastr.error(JSON.stringify(data));
                          else
                            this.toastr.error("Your passcode locked.Please contact Administrator.")
                        }
                      }
                    }
                    else {
                      // this.IsCodeEnteredPhysician = false;
                      this.toastr.error("Your passcode locked.Please contact Administrator.")
                    }
                  });
                  //});      
                }

              }

            } else {
              if (result && result != undefined) {
                this.toastr.error("Security Code must be in numbers");
                this.openDialog(UserRole, datetimectrlname);
              }
            }
          }
        });

        //} else {
        //   this.toastr.error("Please Enter Signature");
        //}
      }

    }

  }
  IsnurseCodeEntered: boolean;
  IsProviderSignOff: boolean = false;
  getProviderSignature(frmgrp, secCode, userrole, signoffdatetimectrl, UserID) {
    //  if (this.EditForms.value.NurseId != undefined && secCode != undefined) {
    if (UserID != undefined && secCode != undefined) {
      //  this.orNoteCommonService.UserSigById(encodeURIComponent(this.EditForms.value.NurseId), secCode).subscribe(data => {
      this.orNoteCommonService.UserSigById(encodeURIComponent(UserID), secCode).subscribe(data => {
        if (data && data != undefined) {
          if (data && data.wrongAttempts != null && data.wrongAttempts != undefined) {
            if (data.wrongAttempts < 5) {
              // this.EnterDefaultDateTime('PhySignOffDateTime');
              // this.datetimeForSign = formatDate(result, 'MM-dd-yyyy hh:mm:ss a', 'en-US');
              // this.consentforms.controls['PhySignOffDateTime'].setValue(this.datetimeForSign);
              // this.IsnurseCodeEntered = false;
              // this.SaveConsentforms(null);

              this.dateservice.getservercurrentdate().subscribe(async result => {
                await result;
                if (userrole == "Nurse") {
                  this.IsnurseCodeEntered = false;
                }
                if (userrole == "Provider") {
                  this.IsProviderSignOff = true;
                }

                const datetimeForSign = formatDate(result, 'MM-dd-yyyy hh:mm:ss a', 'en-US');
                // this.EditForms.controls['NursignoffDateTime'].setValue(datetimeForSign);
                // this.EditForms.controls[signoffdatetimectrl].setValue(datetimeForSign);
                if (frmgrp.controls[signoffdatetimectrl].value == "")
                  frmgrp.controls[signoffdatetimectrl].setValue(datetimeForSign);

                this.SaveConsentforms(userrole);

              }
              );

            }
            else {
              this.toastr.error("Your passcode locked.Please contact Administrator");
            }
          }
          else {
            this.IsnurseCodeEntered = true;
            if (JSON.stringify(data).search("Invalid") == -1)
              this.toastr.error("Invalid Code");
            else if (JSON.stringify(data).search("0 more") == -1)
              this.toastr.error(JSON.stringify(data));
            else
              this.toastr.error("Your passcode locked.Please contact Administrator");
          }
        }
      });
    }
    else {
      this.toastr.error("Please check provider or password");
      this.IsnurseCodeEntered = true;
    }
  }

  ProviderSignoff_Login(frmgrp, userrole, signoffdatetimectrl) {
    this.dateservice.getservercurrentdate().subscribe(async result => {
      await result;
      const datetimeForSign = formatDate(result, 'MM-dd-yyyy hh:mm:ss a', 'en-US');
      frmgrp.controls[signoffdatetimectrl].setValue(datetimeForSign);
      this.SaveConsentforms(userrole);
    });

  }
  SaveConsentforms(role: string) {
    try {
      if (this.Isvalidform()) {

        //this.spinner.show();
        this.savePatientForm(role);

        /* if(this.patientFormId==null ||this.patientFormId==undefined||this.patientFormId==0)
         {   //Insert
           this.savePatientForm(role);
         }
         else
         {  //Update
           this.savePatientForm(role);
     
         }*/
      }
      //this.spinner.hide();

    }
    catch (e) {
      //this.spinner.hide();
      this.showspinner = false;
    }


  }
  iseditPatient: boolean = false;
  iseditNurse: boolean = false;
  iseditProvider: boolean = false;
  iseditClerk: boolean = false;
  iseditOthers: boolean = false;
  ptime: string = "";
  prtime: string = "";
  ntime: string = "";
  ctime: string = "";
  otime: string = "";
  EDITTIME(usertype: string, ctrlid: string) {
    ;
    if (usertype == 'Patient') {
      this.iseditPatient = true;
      this.ptime = this.EditForms.value.PatientsignoffDateTime.toString();
    } else if (usertype == 'Provider') {
      this.iseditProvider = true;
      this.prtime = this.EditForms.value.ProvidersignoffDateTime.toString();
    } else if (usertype == 'Nurse') {
      this.iseditNurse = true;
      this.ntime = this.EditForms.value.NursignoffDateTime.toString();
    } else if (usertype == 'Clerk') {
      this.iseditClerk = true;
      this.ctime = this.EditForms.value.NursignoffDateTime.toString();
    } else if (usertype == 'Others') {
      this.iseditOthers = true;
      this.otime = this.EditForms.value.othsignoffDateTime.toString();
    }

    $('#' + ctrlid).focus();


  }


  CANCELTIME(usertype: string, frmControl: string) {
    if (usertype == 'Patient') {
      this.iseditPatient = false;
      this.EditForms.controls[frmControl].setValue(this.ptime);

    } else if (usertype == 'Provider') {
      this.iseditProvider = false;
      this.EditForms.controls[frmControl].setValue(this.prtime);
    } else if (usertype == 'Nurse') {
      this.iseditNurse = false;
      this.EditForms.controls[frmControl].setValue(this.ntime);
    } else if (usertype == 'Clerk') {
      this.iseditClerk = false;
      this.EditForms.controls[frmControl].setValue(this.ctime);
    } else if (usertype == 'Others') {
      this.iseditOthers = false;
      this.EditForms.controls[frmControl].setValue(this.otime);

    }

  }
  validatetime(datestr: string, userrole: string) {
    try {
      var isvaliddata: Boolean = false
      var regex = /^(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])-[0-9]{4} (0[1-9]|1[0-2]):[0-5][0-9]:[0-5][0-9]\s*([AaPp][Mm])*$/;
      if (datestr == "" || datestr == undefined) {
        // this.toastr.error("Invalid " + userrole + " date & Time ")
        isvaliddata = false;
      }
      else if ((regex.test(datestr)) && (moment(datestr, "MM-DD-YYYY hh:mm:ss a").isValid())) {
        isvaliddata = true;
      }


      if (this.DocLibTargetLocID != Defaults.DocLibraryPatDemographicsID) {
        let sessionvisitdatesignoff = new Date(formatDate(sessionStorage.getItem("PatBoardDate"), 'MM-dd-yyyy', 'en-US'));
        //new Date(formatDate(sessionStorage.getItem("appDate"), 'MM-dd-yyyy', 'en-US'));
        if (isvaliddata) {
          let enteringdatesignoff = new Date(formatDate(datestr.split(' ')[0], 'MM-dd-yyyy', 'en-US'));
          let visitdateval = sessionvisitdatesignoff.getFullYear() + '' + ("0" + (sessionvisitdatesignoff.getMonth() + 1)).slice(-2) + '' + ("0" + sessionvisitdatesignoff.getDate()).slice(-2)
          //       ("0" + sessionvisitdatesignoff.getDate()).slice(-2) + "-" + ("0"+(sessionvisitdatesignoff.getMonth()+1)).slice(-2) + "-" +
          // d.getFullYear()
          let enterdateval = enteringdatesignoff.getFullYear() + '' + ("0" + (enteringdatesignoff.getMonth() + 1)).slice(-2) + '' + ("0" + enteringdatesignoff.getDate()).slice(-2)
          if (visitdateval > enterdateval) {
            // if (enteringdatesignoff >= sessionvisitdatesignoff) {
            this.Savesignaturebtn = false;
            this.toastr.error('Sign off date should be after Visit Date');
            isvaliddata = false;
            this.showspinner = false;
            return false;
          }
          else {
            isvaliddata = true;

          }
        }
      }


      if (isvaliddata) {
        return true;
      } else {
        this.toastr.error("Invalid " + userrole + " date & Time ");
        isvaliddata = false;
        this.Savesignaturebtn = false;
        this.showspinner = false;
      }




    }
    // }
    //   else {
    //     this.toastr.error("Invalid " + userrole + " date & Time ");
    //     return false
    //   }
    // }


    catch (ex) {
      this.toastr.error("Invalid " + userrole + " date & Time ");
      return false;

    }
  }

  SAVETIME(usertype: string, frmControl: string) {
    ;
    if (this.validatetime(this.EditForms.controls[frmControl].value.toString(), usertype)) {
      this.SaveConsentforms(usertype)
      if (usertype == 'Patient')
        this.iseditPatient = false;
      else if (usertype == 'Provider')
        this.iseditProvider = false;
      else if (usertype == 'Nurse')
        this.iseditNurse = false;
      else if (usertype == 'Clerk')
        this.iseditClerk = false;
      else if (usertype == 'Others')
        this.iseditOthers = false;
    }

  }
  EnterDefaultDateTime(frmControl) {

    this.dateservice.getservercurrentdate().subscribe(result => {
      this._ServerdateTime = formatDate(result, 'MM-dd-yyyy hh:mm:ss a', 'en-US');

      var datetimeForSign = this._ServerdateTime;
      // datetimeForSign = formatDate(datetimeForSign, 'MM-dd-yyyy hh:mm:ss a', 'en-US', 'locale');
      datetimeForSign = formatDate(datetimeForSign, 'MM-dd-yyyy hh:mm:ss a', 'en-US');
      this.EditForms.controls[frmControl].setValue(datetimeForSign);
      // this.EditForms.controls["visitDate"].setValue(this.datepipe.transform(this._ServerdateTime,"MM/dd/yyyy"))

    });


  }



  drawStart(type) {
    if (type == 'PatientsignoffDateTime') {
      this.signPadcheckPatient = false;
    } else {
      this.signPadcheckWitness = false;
    }

  }
  tabChanged(tablabelname: string) {
    this.deleteUserLock();
    this.router.navigateByUrl('/' + tablabelname.replace(" ", ""));
  }
  tabChangedOR(event: MatTabChangeEvent, Maintype: string) {
    // this.removejscssfile("SignaturePadHandler1.js", "js")
    // this.removejscssfile("SigWebTablet1.js", "js")

    if (Maintype == 'Head') {

      this.isAuthorizationSigned(event);
      //this.spinner.hide();
    }
    else {
      if (event.tab.textLabel === "Allergies & A/Cs") {
        var tabName = event.tab.textLabel.replace(" & ", "");
        this.router.navigateByUrl('/OR' + tabName.replace(" ", ""));
      } else {
        if (event.tab.textLabel == 'COVID-19 Risk Disclosure') {
          var tabName = event.tab.textLabel.replace("-", "").replace(" ", "");
          this.router.navigateByUrl('/OR' + tabName.replace(" ", ""));
        } else {
          var tabName = event.tab.textLabel.replace(" & ", "");
          this.router.navigateByUrl('/OR' + tabName.replace(" ", ""));
        }
      }
    }
  }


  isAuthorizationSigned(event: any) {
    var tabName = event.tab.textLabel.replace(" & ", "");
    this.router.navigateByUrl('/OR' + tabName.replace(" ", ""));
    // if (event.tab.textLabel === "Allergies & A/Cs") {
    //   var tabName = event.tab.textLabel.replace(" & ", "");
    //   this.router.navigateByUrl('/OR' + tabName.replace(" ", ""));
    //   return;
    // }
    // this.sharedService.getAuthSignOffStatus(sessionStorage.getItem("encounterid"))
    //   .subscribe(
    //     results => {
    //       if (results == "1") {
    //         if (event.tab.textLabel === "Allergies & A/Cs") {
    //           var tabName = event.tab.textLabel.replace(" & ", "");
    //           this.router.navigateByUrl('/OR' + tabName.replace(" ", ""));
    //         } else {
    //           var tabName = event.tab.textLabel.replace(" & ", "");
    //           this.router.navigateByUrl('/OR' + tabName.replace(" ", ""));
    //         }
    //       }
    //       else {
    //         this.checkLock();
    //         const message = `Authorization Consent Form should be signed before proceeding `;
    //         const dialogData = new warningDialogModel('Alert !', message);
    //         const dialogRef = this.dialog.open(WarningDialogComponent, {
    //           maxWidth: '400px',
    //           height: '160px',
    //           data: dialogData
    //         });

    //         this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
    //           this.router.navigate(['/ORConsents']));
    //       }

    //     }
    //   );
  }
  lockedUser: any;
  lockMessage: any;
  DisableFormConsent: string;

  // checkLock() {
  //   //this.lockService.getLockUsers(encodeURIComponent(sessionStorage.getItem("userId")), Defaults.lock_ornote_Impconsentforms, sessionStorage.getItem("FacilityId"), sessionStorage.getItem("encounterid")).subscribe(
  //     var formname="Forms"+this.DocLibTargetLocID;
  //     //this.lockService.getLockUsers(encodeURIComponent(sessionStorage.getItem("userId")), Defaults.lock_demographics_consentforms, sessionStorage.getItem("FacilityId"), CommonComponents.patientId.toString()).subscribe(
  //       this.lockService.getLockUsers(encodeURIComponent(sessionStorage.getItem("userId")), formname, sessionStorage.getItem("FacilityId"), CommonComponents.patientId.toString()).subscribe(

  //     results => {
  //       this.lockedUser = results;
  //       if (this.lockedUser != null && this.lockedUser != undefined) {
  //         this.lockMessage = this.lockedUser.userName + " is working on this " + this.lockedUser.controlName + " form right now ";
  //         this.EditForms.disable();
  //       this.DisableFormConsent='DisableFormConsent';

  //       }
  //       else{
  //         this.DisableFormConsent='';
  //       }
  //     });
  //   }
  checkLock() {
    var formname = "Doclib_ConsentForms_" + this.DocLibTargetLocID;
    var encID_patid = 'PATID' + CommonComponents.patientId.toString()
    this.lockService.getLockUsers(encodeURIComponent(sessionStorage.getItem("userId")), formname, sessionStorage.getItem("FacilityId"), encID_patid)
      .subscribe(
        results => {
          this.lockedUser = results;
          if (this.lockedUser != null && this.lockedUser != undefined) {

            this.EditForms.disable();
            // this.isdisablebtn = true;
            this.DisableFormConsent = 'DisableFormConsent';

            // this.lockMessage = this.lockedUser.userName + " is working on this " + this.lockedUser.controlName + " form right now ";
            this.lockMessage = this.lockedUser.userName + " is working on this Document Library form right now ";

          }
          else {
            this.DisableFormConsent = '';
          }

        });

  }
  deleteUserLock() {
    if (sessionStorage.getItem("userId") != undefined && sessionStorage.getItem("userId") != null) {
      this.lockService.deleteLockUsersInfo(sessionStorage.getItem("userId")).subscribe(data => {
        this.result = data;
      }, (err: any) => {
        console.log(err);
      });
    }
  }
  public signoffEnc: IEncounterData;
  getVisitIsSignedoff() {
    if (this.encounterId != undefined) {
      this.sharedService.getIsSignedoff(this.encounterId, 1).subscribe(data => {
        this.signoffEnc = data;
        if (data != undefined) {
          if (this.signoffEnc.isSignOff == true && this.signoffEnc.lockedby == null && this.signoffEnc.islockorUnlock === false) {
            this.EditForms.disable();
            this.DisableFormConsent = 'DisableFormConsent';
          }
          else if (this.signoffEnc.isSignOff == true && this.signoffEnc.lockedby == sessionStorage.getItem("userId") && this.signoffEnc.islockorUnlock === true) {
            this.EditForms.enable();
            this.checkLock();
          }
          else if (this.signoffEnc.isSignOff == true && this.signoffEnc.lockedby != sessionStorage.getItem("userId") && this.signoffEnc.islockorUnlock === false) {
            this.EditForms.disable();
            this.DisableFormConsent = 'DisableFormConsent';
          }
          else {
            this.EditForms.enable();
            this.checkLock();
          }
        }
        else {
          this.DisableFormConsent = '';
        }
      });
    }
  }
  // clearSignature(signaturepadid) {
  //   if (signaturepadid == 'othsignoffDateTime') {//Others
  //     this.EditForms.patchValue({
  //       othsignoffDateTime: null

  //     });
  //     //this.EditForms.get('othsignoffDateTime').reset();

  //     if (this.IsPadNotLCD1 == false) {
  //       // clear sign from canvas for new signature pad
  //       var canvas1 = document.getElementById("cnvnotLCD1") as HTMLCanvasElement;
  //       var context1 = canvas1.getContext('2d');
  //       var table = $(canvas1).closest("table");
  //       table.find("canvas").remove();
  //       $('<canvas id="cnvnotLCD1" width="300" height="111"></canvas>').appendTo(table).find('tbody tr td')
  //       document.getElementById("EsignOtherSignOff").click();
  //     } else if (this.IsPadLCD1 == false) {
  //       var canvas3 = document.getElementById("cnv1") as HTMLCanvasElement;
  //       var context1 = canvas3.getContext('2d');
  //       var table = $(canvas3).closest("table");
  //       table.find("canvas").remove();
  //       $('<canvas id="cnv1" width="300" height="111"></canvas>').appendTo(table).find('tbody tr td')
  //       document.getElementById("EsignOtherSignOff").click();
  //     }

  //     else {
  //       if (this.signaturePad2 != undefined) {
  //         this.signaturePad2.clear();
  //         this.signPadcheck = false;
  //         document.getElementById('sigImageData')["value"] = "Base64String: "
  //         var canvas = document.getElementById("cnv1") as HTMLCanvasElement;
  //         var context = canvas.getContext('2d');
  //         context.clearRect(0, 0, canvas.width, canvas.height);
  //         return;
  //       }
  //     }
  //   }
  //   else if (signaturepadid == 'PatientsignoffDateTime') {

  //     //Patient
  //     //  this.EditForms.get('signoffDateTime').reset();
  //     this.EditForms.patchValue({
  //       PatientsignoffDateTime: null

  //     });


  //     if (this.IsPadNotLCD == false) {
  //       // clear sign from canvas for new signature pad
  //       var canvas1 = document.getElementById("cnvnotLCD") as HTMLCanvasElement;
  //       var context1 = canvas1.getContext('2d');
  //       var table = $(canvas1).closest("table");
  //       table.find("canvas").remove();
  //       $('<canvas id="cnvnotLCD" width="300" height="111"></canvas>').appendTo(table).find('tbody tr td')
  //       document.getElementById("EsignPatientSignOff").click();
  //     }
  //     else if (this.IsPadLCD == false) {
  //       this.IsPadNotLCD = false;
  //       var canvas2 = document.getElementById("cnv") as HTMLCanvasElement;
  //       var context2 = canvas2.getContext('2d');
  //       var table = $(canvas2).closest("table");
  //       table.find("canvas").remove();
  //       $('<canvas id="cnv" width="300" height="111"></canvas>').appendTo(table).find('tbody tr td')
  //       document.getElementById("EsignPatientSignOff").click();
  //     }
  //     else {
  //       if (this.signaturePad != undefined) {
  //         this.signaturePad.clear();
  //         this.signPadcheck = false;
  //         document.getElementById('sigImageData1')["value"] = "Base64String: "
  //         var canvas = document.getElementById("cnv") as HTMLCanvasElement;
  //         var context = canvas.getContext('2d');
  //         context.clearRect(0, 0, canvas.width, canvas.height);
  //         return;
  //       }
  //     }
  //   }

  // }

  checkEmptySignature: string = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAABvCAYAAABWxv0DAAAAAXNSR0IArs4c6QAAA0VJREFUeF7t1AEJAAAMAsHZv/RyPNwSyE3cOQIECEQEFskpJgECBM5gKQEBAhkBg5V5laAECBgsHSBAICNgsDKvEpQAAYOlAwQIZAQMVuZVghIgYLB0gACBjIDByrxKUAIEDJYOECCQETBYmVcJSoCAwdIBAgQyAgYr8ypBCRAwWDpAgEBGwGBlXiUoAQIGSwcIEMgIGKzMqwQlQMBg6QABAhkBg5V5laAECBgsHSBAICNgsDKvEpQAAYOlAwQIZAQMVuZVghIgYLB0gACBjIDByrxKUAIEDJYOECCQETBYmVcJSoCAwdIBAgQyAgYr8ypBCRAwWDpAgEBGwGBlXiUoAQIGSwcIEMgIGKzMqwQlQMBg6QABAhkBg5V5laAECBgsHSBAICNgsDKvEpQAAYOlAwQIZAQMVuZVghIgYLB0gACBjIDByrxKUAIEDJYOECCQETBYmVcJSoCAwdIBAgQyAgYr8ypBCRAwWDpAgEBGwGBlXiUoAQIGSwcIEMgIGKzMqwQlQMBg6QABAhkBg5V5laAECBgsHSBAICNgsDKvEpQAAYOlAwQIZAQMVuZVghIgYLB0gACBjIDByrxKUAIEDJYOECCQETBYmVcJSoCAwdIBAgQyAgYr8ypBCRAwWDpAgEBGwGBlXiUoAQIGSwcIEMgIGKzMqwQlQMBg6QABAhkBg5V5laAECBgsHSBAICNgsDKvEpQAAYOlAwQIZAQMVuZVghIgYLB0gACBjIDByrxKUAIEDJYOECCQETBYmVcJSoCAwdIBAgQyAgYr8ypBCRAwWDpAgEBGwGBlXiUoAQIGSwcIEMgIGKzMqwQlQMBg6QABAhkBg5V5laAECBgsHSBAICNgsDKvEpQAAYOlAwQIZAQMVuZVghIgYLB0gACBjIDByrxKUAIEDJYOECCQETBYmVcJSoCAwdIBAgQyAgYr8ypBCRAwWDpAgEBGwGBlXiUoAQIGSwcIEMgIGKzMqwQlQMBg6QABAhkBg5V5laAECBgsHSBAICNgsDKvEpQAAYOlAwQIZAQMVuZVghIgYLB0gACBjIDByrxKUAIEDJYOECCQETBYmVcJSoCAwdIBAgQyAgYr8ypBCRAwWDpAgEBG4AH5RABw7VLF5wAAAABJRU5ErkJggg=="
  clearSignature(signaturepadid) {
    // this.removejscssfile("SignaturePadHandler1.js", "js")
    // this.removejscssfile("SigWebTablet1.js", "js")

    // this.removejscssfile("SignaturePadHandler.js", "js")
    // this.removejscssfile("SigWebTablet.js", "js")
    // this.Savesignaturebtn = false;
    if (signaturepadid == 'othsignoffDateTime') {      //Others signature 
      if (this.sigpadoth.toDataURL() != this.checkEmptySignature) {
        const message = "Are you sure you want to clear this signature? ";
        const dialogData = new ConfirmDialogModel('Confirm Action', message);
        const dialogRef = this.dialog.open(DeleteDocumentComponent, {
          // maxWidth: '400px',
          width: '300px',
          height: '130px',
          data: dialogData
        });

        dialogRef.afterClosed().subscribe(dialogResult => {
          this.result = dialogResult;
          if (this.result) {
            this.EditForms.patchValue({
              othsignoffDateTime: null
            });
            this.sigpadoth.clear();
            // this.signPadcheck = false;
            this.signPadcheckWitness = true;
            this.SignatureCheckIdWitness = false;
          } else {
            //  this.show = true;
          }
        });
      }


      // var canvas = document.getElementById("cnvnotLCD1") as HTMLCanvasElement;
      // var context = canvas.getContext('2d');
      // context.clearRect(0, 0, canvas.width, canvas.height);
      // if (document.getElementById('sigImageDataPatient') != null) {
      //   document.getElementById('sigImageDataPatient')["value"] = "Base64String: "
      // }
      // //this.EditForms.get('othsignoffDateTime').reset();
      // if (this.IsPadNotLCD1 == false) {
      //   // clear sign from canvas for new signature pad
      //   var canvas1 = document.getElementById("cnvnotLCD1") as HTMLCanvasElement;
      //   var context1 = canvas1.getContext('2d');
      //   var table = $(canvas1).closest("table");
      //   table.find("canvas").remove();
      //   $('<canvas id="cnvnotLCD1" width="300" height="111"></canvas>').appendTo(table).find('tbody tr td')
      //   document.getElementById("EsignOtherSignOff").click();
      // } else {
      //   if (this.IsPadLCD1 == false) {
      //     this.signaturePad2.clear();
      //     if (document.getElementById('sigImageDataPatient') != null) {
      //       document.getElementById('sigImageDataPatient')["value"] = "Base64String: "
      //     }
      //     var canvas3 = document.getElementById("cnv1") as HTMLCanvasElement;
      //     var context2 = canvas3.getContext('2d');
      //     var table = $(canvas3).closest("table");
      //     table.find("canvas").remove();
      //     $('<canvas id="cnv1" width="300" height="111"></canvas>').appendTo(table).find('tbody tr td')
      //     document.getElementById("EsignOtherSignOff").click();
      //   }
      // }
    }
    else {
      if (this.sigPatient.toDataURL() != this.checkEmptySignature) {
        const message = "Are you sure you want to clear this signature? ";
        const dialogData = new ConfirmDialogModel('Confirm Action', message);
        const dialogRef = this.dialog.open(DeleteDocumentComponent, {
          // maxWidth: '400px',
          width: '300px',
          height: '130px',
          data: dialogData
        });

        dialogRef.afterClosed().subscribe(dialogResult => {
          this.result = dialogResult;
          if (this.result) {
            this.EditForms.patchValue({
              PatientsignoffDateTime: null
            });
            this.sigPatient.clear();
            //this.signPadcheck = false;
            this.signPadcheckPatient = true;
            this.checkSignaturePop = false;
          } else {
            //  this.show = true;
          }
        });
      }



      // if (document.getElementById('sigImageData1') != null) {
      //   document.getElementById('sigImageData1')["value"] = "Base64String: "
      // }
      // var canvas = document.getElementById("cnvnotLCD") as HTMLCanvasElement;
      // var context = canvas.getContext('2d');
      // context.clearRect(0, 0, canvas.width, canvas.height);



      // if (this.IsPadNotLCD == false) {
      //   // clear sign from canvas for new signature pad
      //   var canvas0 = document.getElementById("cnvnotLCD") as HTMLCanvasElement;
      //   var context0 = canvas0.getContext('2d');
      //   var table = $(canvas0).closest("table");
      //   table.find("canvas").remove();
      //   $('<canvas id="cnvnotLCD" width="300" height="111"></canvas>').appendTo(table).find('tbody tr td')
      //   document.getElementById("EsignPatientSignOff").click();
      // } else {
      //   if (this.IsPadLCD == false) {

      //     this.signaturePad.clear();
      //     this.signPadcheck = false;
      //     if (document.getElementById('sigImageData1') != null) {
      //       document.getElementById('sigImageData1')["value"] = "Base64String: "
      //     }
      //     var canvas2 = document.getElementById("cnv") as HTMLCanvasElement;
      //     var context2 = canvas2.getContext('2d');
      //     var table = $(canvas2).closest("table");
      //     table.find("canvas").remove();
      //     $('<canvas id="cnv" width="300" height="111"></canvas>').appendTo(table).find('tbody tr td')
      //     document.getElementById("EsignPatientSignOff").click();
      //   }
      // }
    }

  }

  savePatientForm(signaturerole: string) {
    this.Savesignaturebtn = true;
    this.showspinner = true;
    try {
      if (!this.Isvalidform())
        return false;

      //this.spinner.show();

      if (signaturerole == 'Patient') {
        let objFormDetails_Signature = this.signaturePad.toDataURL();
        //  if (objFormDetails_Signature == '') {
        if (this.signPadcheckPatient == false) {
          if (this.signaturePad.isEmpty() || objFormDetails_Signature == null || objFormDetails_Signature == "" || objFormDetails_Signature == 'undefined') {
            // if(this.signaturePad.isEmpty() || this.EditForms.value.signoffDateTime == "" || this.EditForms.value.signoffDateTime == null || this.EditForms.value.practiceForm == ""){
            this.toastr.warning("Please enter Patient Signature ");
            this.Savesignaturebtn = false;
            this.showspinner = false;
            //this.spinner.hide();
            return;
          }
        }
        else {
          if (objFormDetails_Signature == null || objFormDetails_Signature == "" || objFormDetails_Signature == 'undefined') {
            this.toastr.warning("Please enter Patient Signature ");
            this.Savesignaturebtn = false;
            this.showspinner = false;
            //this.spinner.hide();
            return;
          }
        }
        //    }



        if (this.EditForms.value.PatientsignoffDateTime == "" || this.EditForms.value.PatientsignoffDateTime == null) {
          this.toastr.warning("Invalid date Please enter Patient Signature ");
          this.Savesignaturebtn = false;
          this.showspinner = false;
          //this.spinner.hide();
          return;
        }
        else {
          if (!this.validatetime(this.EditForms.value.PatientsignoffDateTime, signaturerole))
            //this.Savesignaturebtn = true;
            return;
        }
      }
      if (signaturerole == 'Others') {
        let objFormDetails_Signature = this.signaturePad2.toDataURL();
        if (this.signPadcheckWitness == false) {
          if (this.signaturePad2.isEmpty() || objFormDetails_Signature == null || objFormDetails_Signature == "" || objFormDetails_Signature == 'undefined') {
            // if(this.signaturePad.isEmpty() || this.EditForms.value.signoffDateTime == "" || this.EditForms.value.signoffDateTime == null || this.EditForms.value.practiceForm == ""){
            this.toastr.warning("Please enter Others Signature ");
            this.Savesignaturebtn = false;
            this.showspinner = false;
            //this.spinner.hide();
            return;
          }
        }
        else {
          if (objFormDetails_Signature == null || objFormDetails_Signature == "" || objFormDetails_Signature == 'undefined') {
            this.toastr.warning("Please enter Others Signature ");
            this.Savesignaturebtn = false;
            this.showspinner = false;
            //this.spinner.hide();
            return;
          }
        }

        if (this.EditForms.value.othsignoffDateTime == "" || this.EditForms.value.othsignoffDateTime == null) {
          this.toastr.warning("Invalid date Please enter Others Signature ");
          this.Savesignaturebtn = false;
          this.showspinner = false;
          //this.spinner.hide();
          return;
        } else {
          if (!this.validatetime(this.EditForms.value.othsignoffDateTime, signaturerole))
            return;
        }

        if (this.EditForms.value.OthName == '' || this.EditForms.value.OthName == undefined) {
          this.toastr.warning("Please Enter Witness name");
          this.Savesignaturebtn = false;
          this.showspinner = false;
          //this.EditForms.patchValue({        othsignoffDateTime:''      });
          //this.spinner.hide();
          return;

        }

        if (this.EditForms.value.OthRelation == '' || this.EditForms.value.OthRelation == undefined) {
          this.toastr.warning("Please Enter Witness Relation ");
          this.Savesignaturebtn = false;
          this.showspinner = false;
          //this.EditForms.patchValue({        othsignoffDateTime:''      });
          //this.spinner.hide();
          return;

        }

      }

      if (Number.isNaN(this.consentNameId)) { //(Number.isNaN(this.EditForms.value.practiceForm)

        this.toastr.warning(" Please select Practice Form ");
        this.showspinner = false;
        //this.spinner.hide();
        return;
      }
      //var patientNameId = CommonComponents.patientId;
      // var objFormDetails: IPatientForms = this.EditForms.value;
      var objFormDetails = new IDocLibPatientForms();//= this.EditForms.value;
      objFormDetails.TargetLocID = this.DocLibTargetLocID;
      objFormDetails.FormName = this.ConsentFormName
      this.EditForms.value.Formseditor = this.initEditor.getContents();
      //objFormDetails.IsActive=true;
      objFormDetails.PatientID = CommonComponents.patientId;
      objFormDetails.EMRDocLibID = this.patientFormId;

      objFormDetails.CreatedUserBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
      objFormDetails.IsActive = this.EditForms.value.isActive == true ? true : false;

      objFormDetails.IsReadyToSignoff = this.IsReadytoSignOff; //siva
      var effDate = this.datepipe.transform(this.EditForms.value.effectiveDate, 'yyyy-MM-dd');
      objFormDetails.ValidFrom = effDate != null ? new Date(effDate) : null;
      if (this.EditForms.value.exprirationDate == "Invalid Date")
        this.EditForms.value.exprirationDate = this._ServerdateTime;

      var expDate = this.datepipe.transform(this.EditForms.value.exprirationDate, 'yyyy-MM-dd');
      objFormDetails.ValidUpto = expDate != null ? new Date(expDate) : null;
      if (this.EditForms.value.visitDate == "Invalid Date")
        this.EditForms.value.visitDate = this._ServerdateTime;
      var visitDate = this.datepipe.transform(this.EditForms.value.visitDate, 'yyyy-MM-dd');
      objFormDetails.VisitDate = visitDate != null ? new Date(visitDate) : null;

      objFormDetails.FormHTMlConsentData = document.getElementById("editibleCheckboxId").innerHTML; //this.EditForms.value.Formseditor
      // this.DocLibConsentHtml;
      // alert(document.getElementById("editibleCheckboxId").innerHTML)
      objFormDetails.FormData = document.getElementById("editibleCheckboxId").innerHTML;//this.EditForms.value.Formseditor  // this._htmlstr
      //this.EditForms.value.description;

      if (objFormDetails.ValidFrom != null)
        if (objFormDetails.ValidUpto != null) {
          if (new Date(this.EditForms.value.exprirationDate) < new Date(this.EditForms.value.effectiveDate)) {
            //if (objFormDetails.effectiveDate <  objFormDetails.exprirationDate) {
            const message = ' expiration  date should be greater than effective date ';
            const dialogData = new warningDialogModel('Alert !', message);
            const dialogRef = this.dialog.open(WarningDialogComponent, {
              maxWidth: '400px',
              height: '150px',
              data: dialogData

            });
            dialogRef.afterClosed().subscribe(dialogResult => {
              this.result = dialogResult;
              this.Savesignaturebtn = false;
            });
            this.showspinner = false;
            return;
          }
        }

      if (sessionStorage.getItem("LocationId") == null || sessionStorage.getItem("LocationId") == '' || sessionStorage.getItem("LocationId") == undefined) {
        this.sharedService.getLocationsByLoginUser().subscribe(async data => {
          Number(data);
          sessionStorage.setItem("LocationId", data);
        });
      }
      objFormDetails.LocationID = Number(sessionStorage.getItem("LocationId"));
      objFormDetails.FacilityID = Number(sessionStorage.getItem('FacilityId'));

      if (this.DocLibTargetLocID == Defaults.DocLibraryPatDemographicsID) {
        objFormDetails.EncounterID = '';
        objFormDetails.PatientAppointmentID = '';

      }
      else {
        //check in , visit, or
        objFormDetails.EncounterID = CommonComponents.encounterId
        if (sessionStorage.getItem("appId") != null || sessionStorage.getItem("appId") != '' || sessionStorage.getItem("appId") != undefined) {

          objFormDetails.PatientAppointmentID = sessionStorage.getItem("appId");
        }
      }
      // objFormDetails.EncounterID = CommonComponents.encounterId
      // if (sessionStorage.getItem("appId") != null || sessionStorage.getItem("appId") != '' || sessionStorage.getItem("appId") != undefined) {

      //   objFormDetails.PatientAppointmentID = sessionStorage.getItem("appId");
      // }

      objFormDetails.FormID = this.consentNameId//this.EditForms.value.practiceForm; //formid in dropdown


      if (signaturerole == 'Patient') {
        //his.provi
        if (this.signPadcheckPatient == false) {
          objFormDetails.Signature = this.signaturePad.toDataURL();
          if (objFormDetails.Signature != "" && objFormDetails.Signature != 'undefined') {
            objFormDetails.Signature = objFormDetails.Signature.replace('data:image/png;base64,', '');
            //if(this.ISOthersSignature)
            //{
            objFormDetails.SignatureBY = this.EditForms.controls['patientId'].value;
            objFormDetails.SignatureDate = this.EditForms.controls["PatientsignoffDateTime"].value;;
            // }
            objFormDetails.SignatureRole = signaturerole; //Signaturerolename
            objFormDetails.SignatureID = 1//this.CurentSigntureBY; //signatureroleid
          }
        }
        else {
          if (this.checkSignaturePop == true) {
            objFormDetails.Signature = document.getElementById('sigImageData')["value"];
            if (objFormDetails.Signature != "" && objFormDetails.Signature != 'undefined') {
              objFormDetails.Signature = encodeURIComponent(objFormDetails.Signature.replace('data:image/png;base64,', ''));
              objFormDetails.SignatureBY = this.EditForms.controls['patientId'].value;
              objFormDetails.SignatureDate = this.EditForms.controls["PatientsignoffDateTime"].value;;
              objFormDetails.SignatureRole = signaturerole; //Signaturerolename
              objFormDetails.SignatureID = 1//this.CurentSigntureBY; //signatureroleid
            } else {
              objFormDetails.Signature = "";
            }
          }

          // if (document.getElementById('sigImageDataPatient')["value"] != "" && document.getElementById('sigImageDataPatient')["value"] != undefined) {
          //   if (document.getElementById('sigImageDataPatient')["value"] == "Base64String: ") {
          //     if (document.getElementById("displayModelNumber").innerHTML == "0") {
          //       this.toastr.error("Click on 'Accept' button to save the Signature")
          //     } else {
          //       this.toastr.error("user has to click on 'OK' button on the signature pad.")
          //     }
          //     return false;
          //   }
          //   else {
          //     objFormDetails.Signature = document.getElementById('sigImageDataPatient')["value"];
          //     objFormDetails.SignatureBY = this.EditForms.controls['patientId'].value;
          //     objFormDetails.SignatureDate = this.EditForms.controls["PatientsignoffDateTime"].value;;
          //     objFormDetails.SignatureRole = signaturerole; //Signaturerolename
          //     objFormDetails.SignatureID = 1//this.CurentSigntureBY; //signatureroleid
          //   }
          // }
          // else {
          //   objFormDetails.Signature = "";
          // }
        }
      }
      else if (signaturerole == "Nurse") {

        // objFormDetails.Signature = this.signaturePad.toDataURL();
        // if (objFormDetails.Signature != "" && objFormDetails.Signature != 'undefined') {
        //   objFormDetails.Signature = objFormDetails.Signature.replace('data:image/png;base64,', '');
        //if(this.ISOthersSignature)
        //{
        objFormDetails.SignatureBY = encodeURIComponent(this.signNurseId);//this.EditForms.controls['NurseId'].value;
        objFormDetails.SignatureDate = this.EditForms.controls["NursignoffDateTime"].value;;
        // }
        objFormDetails.SignatureRole = signaturerole; //Signaturerolename
        objFormDetails.SignatureID = 2//this.CurentSigntureBY; //signatureroleid

      }
      else if (signaturerole == 'Provider') {

        // objFormDetails.Signature = this.signaturePad.toDataURL();
        // if (objFormDetails.Signature != "" && objFormDetails.Signature != 'undefined') {
        //   objFormDetails.Signature = objFormDetails.Signature.replace('data:image/png;base64,', '');
        //if(this.ISOthersSignature)
        //{
        objFormDetails.SignatureBY = encodeURIComponent(this.providerNameId);//this.EditForms.controls['ProviderID'].value;
        objFormDetails.SignatureDate = this.EditForms.controls["ProvidersignoffDateTime"].value;;
        // }
        objFormDetails.SignatureRole = signaturerole; //Signaturerolename
        objFormDetails.SignatureID = 3//this.CurentSigntureBY; //signatureroleid

      }
      else if (signaturerole == 'Clerk') {
        // objFormDetails.Signature = this.signaturePad.toDataURL();
        // if (objFormDetails.Signature != "" && objFormDetails.Signature != 'undefined') {
        //   objFormDetails.Signature = objFormDetails.Signature.replace('data:image/png;base64,', '');
        //if(this.ISOthersSignature)
        //{
        objFormDetails.SignatureBY = encodeURIComponent(this.clerkNameId);//this.EditForms.controls['ClerkId'].value;
        objFormDetails.SignatureDate = this.EditForms.controls["ClerksignoffDateTime"].value;;
        // }
        objFormDetails.SignatureRole = signaturerole; //Signaturerolename
        objFormDetails.SignatureID = 4//this.CurentSigntureBY; //signatureroleid

      } else if (signaturerole == 'Others') {

        if (this.signPadcheckWitness == false) {
          objFormDetails.Signature = this.signaturePad2.toDataURL();
          if (objFormDetails.Signature != "" && objFormDetails.Signature != 'undefined') {
            objFormDetails.Signature = objFormDetails.Signature.replace('data:image/png;base64,', '');
            //if(this.ISOthersSignature)
            //{
            objFormDetails.SignatureBY = this.EditForms.controls['OthName'].value;
            objFormDetails.SignatureDate = this.EditForms.controls["othsignoffDateTime"].value;
            objFormDetails.OtherInfo = this.EditForms.controls["othInfo"].value;
            // }
            // objFormDetails.SignatureRole=signaturerole; //Signaturerolename
            objFormDetails.SignatureRole = this.EditForms.controls['OthRelation'].value;
            objFormDetails.SignatureID = 5//this.CurentSigntureBY; //signatureroleid
          }
        }
        else {
          if (this.SignatureCheckIdWitness == true) {
            // objFormDetails.Signature = document.getElementById('sigImageData')["value"];
            // if (objFormDetails.Signature != "" && objFormDetails.Signature != 'undefined') {
            //   objFormDetails.Signature = encodeURIComponent(objFormDetails.Signature.replace('data:image/png;base64,', ''));
            //   objFormDetails.SignatureBY = this.EditForms.controls['patientId'].value;
            //   objFormDetails.SignatureDate = this.EditForms.controls["PatientsignoffDateTime"].value;;
            //   objFormDetails.SignatureRole = this.EditForms.controls['OthRelation'].value;
            //   objFormDetails.SignatureID = 2//this.CurentSigntureBY; //signatureroleid
            // } else {
            //   objFormDetails.Signature = "";
            // }

            objFormDetails.Signature = document.getElementById('sigImageDataWitness')["value"];
            objFormDetails.SignatureBY = this.EditForms.controls['OthName'].value;
            objFormDetails.SignatureDate = this.EditForms.controls["othsignoffDateTime"].value;
            objFormDetails.OtherInfo = this.EditForms.controls["othInfo"].value;
            objFormDetails.SignatureRole = this.EditForms.controls['OthRelation'].value;
            objFormDetails.SignatureID = 5//this.CurentSigntureBY; //signatureroleid
          } else {
            objFormDetails.Signature = "";
          }
          // if (document.getElementById('sigImageData1')["value"] != "" && document.getElementById('sigImageData1')["value"] != undefined) {
          //   if (document.getElementById('sigImageData1')["value"] == "Base64String: ") {
          //     if (document.getElementById("displayModelNumber1").innerHTML == "0") {
          //       this.toastr.error("Click on 'Accept' button to save the Signature")
          //     } else {
          //       this.toastr.error("user has to click on 'OK' button on the signature pad.")
          //     }
          //     return false;
          //   }
          //   else {
          //     objFormDetails.Signature = document.getElementById('sigImageData1')["value"];
          //     objFormDetails.SignatureBY = this.EditForms.controls['OthName'].value;
          //     objFormDetails.SignatureDate = this.EditForms.controls["othsignoffDateTime"].value;
          //     objFormDetails.OtherInfo = this.EditForms.controls["othInfo"].value;
          //     objFormDetails.SignatureRole = this.EditForms.controls['OthRelation'].value;
          //     objFormDetails.SignatureID = 5//this.CurentSigntureBY; //signatureroleid
          //   }
          // }
          // else {
          //   objFormDetails.Signature = "";
          // }
        }
      }
      else {

        objFormDetails.Signature = '';
        //if(this.ISOthersSignature)
        //{
        objFormDetails.SignatureBY = '';
        objFormDetails.SignatureDate = new Date();
        // }
        //        objFormDetails.SignatureRole=signaturerole; //Signaturerolename
        objFormDetails.SignatureRole = '';
        objFormDetails.SignatureID = 0//this.CurentSigntureBY; //signatureroleid
      }


      var str = '';
      // if (this.EditForms.controls['NurseId'].value == "" || this.EditForms.controls['NurseId'].value == null || this.EditForms.controls['NurseId'].value == undefined) { str = '@0' } else { str = '@' + this.signNurseId } //this.EditForms.controls['NurseId'].value;
      // if (this.EditForms.controls['ProviderID'].value == "" || this.EditForms.controls['ProviderID'].value == null || this.EditForms.controls['ProviderID'].value == undefined) { str = str + ',0' } else {
      //   let provideObj = this.providersDocList.filter(x => x.fullName === this.EditForms.controls['ProviderID'].value);
      //   if (provideObj.length != 0) {
      //     this.providerNameId = provideObj[0].userId;
      //   }
      //   str = str + ',' + this.providerNameId
      // }//this.EditForms.controls['ProviderID'].value;
      // if (this.EditForms.controls['ClerkId'].value == "" || this.EditForms.controls['ClerkId'].value == null || this.EditForms.controls['ClerkId'].value == undefined) { str = str + ',0' } else { str = str + ',' + this.clerkNameId }//this.EditForms.controls['ClerkId'].value
      // if (this.EditForms.controls['OthName'].value == "" || this.EditForms.controls['OthName'].value == null || this.EditForms.controls['OthName'].value == undefined) { str = str + ',0:0@' } else { str = str + ',' + this.EditForms.controls['OthName'].value + ':' + this.EditForms.controls['OthRelation'].value + '@' }
      str = this.createJSON();
      objFormDetails.SignatureList = str;

      objFormDetails.ExpirationDays = this.Expirationdays;
      objFormDetails.DocDestID = this.DocDestID;
      objFormDetails.ProviderId = this.providerNameId;
      objFormDetails.IsProviderSignOff = this.IsProviderSignOff;
      objFormDetails.ReadytoSignOffOn = this._ServerdateTime;

      if (sessionStorage.getItem("FormScreenType") != null && sessionStorage.getItem("FormScreenType") != undefined && sessionStorage.getItem("FormScreenType") != "") {
        objFormDetails.ScreenType = sessionStorage.getItem("FormScreenType");
      }

      this.patientformService.DocLibsavePatientFormInfo(objFormDetails, signaturerole == 'Reset').subscribe(data => {

        this.result = data;

        // this.IsReadytoSignOff=false;
        this.Savesignaturebtn = false;
        this.showspinner = false;
        //this.spinner.hide();
        if (!Number.isNaN(this.result)) {
          $("span").css("pointer-events", "none");
          this.toastr.success("Consent Form created Successfully");
          this.showspinner = false;
          if ((this.patientFormId == null || this.patientFormId == undefined || this.patientFormId == 0)) {
            this.patientFormId = this.result;
            this.EditForms.controls['practiceForm'].disable();
            //  this.onEditMode( this.patientFormId);
            //  this.router.navigateByUrl(this.router.url+'/'+this.result.toString());
            // this.onCancelClick();
          }
          if (this.IsReadytoSignOff == true) {
            this.IsProviderDisable = true;
          } else {
            this.IsProviderDisable = false;
          }
        } else {
          this.toastr.warning(this.result);
          return;
        }


        if (signaturerole == 'Reset') {
          // this.onEditMode(this.patientFormId);
          var consentMasterData: IDocLibPatientForms[];
          //this.SelectedConsentMasterID= event.target.value
          this.consentMasterService.getEMRConsentDetails_ConsentID(this.patientFormId)
            .subscribe(data => {
              consentMasterData = data;
              if (consentMasterData != undefined && consentMasterData != null && consentMasterData.length > 0) {
                let htmlstr = consentMasterData[0].FormData //.ConsentData;
                // htmlstr = this.replaceAll(htmlstr, "?", "");
                htmlstr = this.replaceAll(htmlstr, "[[", '');
                htmlstr = this.replaceAll(htmlstr, "]]", '');
                this.DocLibConsentHtml = htmlstr;
                this._htmlstr = htmlstr;
                // this.labelHtml = this.sanitizer.bypassSecurityTrustHtml(htmlstr);
                this.labelHtml = this._htmlstr;
                this.initEditor.setContents('');
                this.initEditor.setContents(this.labelHtml);

              }
            });
        }

        if (signaturerole == 'Provider') {
          this.isProvidersigned = true;
        }
        else if (signaturerole == 'Nurse') {
          this.isNurseSigned = true;
        }
        else if (signaturerole == 'Patient') {
          this.isPatientSigned = true;
        }
        else if (signaturerole == 'Clerk') {
          this.isClerkSigned = true;
        }
        else if (signaturerole == 'Others') {
          this.isOtherSigned = true;
        }
        this.enableReadyToSignOff();
        if (this.IsAllSignsareCompleted()) {
          this.saveToChart();
        }
        //signaturerole=='' &&




        //     if(this.DocLibTargetLocID==Defaults.DocLibraryPatDemographicsID){
        //       this.router.navigateByUrl('Demographics/ConsentForms/'+this.DocLibTargetLocID.toString());

        //  }else
        //  {

        //  }



      });




      /* }
       else
       {
         
         // Only save the signatures
        // this.patientformService.
        this.patientformService.DocLibsaveSignatureConsentForm(objFormDetails).subscribe(data=>{
          this.result =data;
          //this.spinner.hide();
          this.toastr.success(this.result);
   
          if(this.DocLibTargetLocID==Defaults.DocLibraryPatDemographicsID){
           this.router.navigateByUrl('Demographics/ConsentForms/'+this.DocLibTargetLocID.toString());
      }else
      {
   
      }
        });
   
   
   
       }*/
    }
    catch (ex) {
      console.log(ex);
      this.showspinner = false;
    }
    finally {
      //this.spinner.hide();
    }

  }


  createJSON() {
    var jsonObj = [];
    //let  item = {}
    if (this.ISNurseSignature == true) {
      var item = {}
      item["SignatureID"] = "2";
      // item ["UserRole"] = 'Nurse';
      item["UserName"] = encodeURIComponent(this.signNurseId);
      item["signoffdate"] = this.EditForms.controls["NursignoffDateTime"].value;
      jsonObj.push(item);
    }
    if (this.IsPatientSignature == true) {
      var item = {}
      item["SignatureID"] = "1";
      // item ["UserRole"] = 'Patient';
      item["UserName"] = this.EditForms.controls['patientId'].value;
      item["signoffdate"] = this.EditForms.controls["PatientsignoffDateTime"].value;
      jsonObj.push(item);
    }
    if (this.IsClerkSignature == true) {
      var item = {}
      item["SignatureID"] = "4";
      //  item ["UserRole"] = 'Clerk';
      item["UserName"] = encodeURIComponent(this.clerkNameId);
      item["signoffdate"] = this.EditForms.controls["ClerksignoffDateTime"].value;
      jsonObj.push(item);
    }
    if (this.ISOthersSignature == true) {
      var item = {}
      item["SignatureID"] = "5";
      // item ["UserRole"] = 'Other';
      item["UserName"] = this.EditForms.controls['OthName'].value;
      item["signoffdate"] = this.EditForms.controls["othsignoffDateTime"].value;
      item["otherinfo"] = this.EditForms.controls["othInfo"].value;
      item["Relation"] = this.EditForms.controls['OthRelation'].value;

      jsonObj.push(item);
    }
    if (this.ISProviderSignature == true) {
      var item = {}
      item["SignatureID"] = "3";
      // item ["UserRole"] = 'Provider';
      item["UserName"] = encodeURIComponent(this.providerNameId);
      item["signoffdate"] = this.EditForms.controls["ProvidersignoffDateTime"].value;
      jsonObj.push(item);
    }



    var str = JSON.stringify(jsonObj)

    return str;
  }
  onCancelClick() {
    /* if (this.headerVisibility == true) {
       this.router.navigate(['Demographics/Forms']);
     } else {
       //this.router.navigateByUrl('/CheckIn?patId=' + sessionStorage.getItem("patientId") + '&appId=' + sessionStorage.getItem("appId") + '&tabIndex=3');
       this.router.navigateByUrl('/CheckInForms');
     }*/


    if (this.DocLibTargetLocID == Defaults.DocLibraryPatDemographicsID) {
      this.router.navigateByUrl('Demographics/ConsentForms/' + this.DocLibTargetLocID.toString());
    } //else if(this.DocLibTargetLocID==Defaults.DocLibraryVisitNote)
    //  this.router.navigateByUrl('ConsentForms?DocLibTargetLocID='+ Defaults.DocLibraryVisitNote);


    else  //if(this.DocLibTargetLocID==Defaults.DocLibraryCheckinForm)
    {
      this.router.navigateByUrl('/ConsentForms/' + this.DocLibTargetLocID.toString());

    }
  }


  getPatientFormDetailsById() {
    if (this.patientFormId > 0) {


      this.patientformService.getPatientFormInfoById(this.patientFormId).subscribe(data => {
        // this.formName=data.practiceFormTitle;
        /* if (data.practiceForm == 9) {
           this.hide = true;
 
         } else {
           this.hide = false;
         }*/
        if (data != null && data != undefined) {
          this.signaturePad.clear();
          this.EditForms.patchValue({
            practiceForm: data.practiceForm,
            //  effectiveDate: data.effectiveDate,
            exprirationDate: data.exprirationDate,
            signoffDateTime: data.signoffDateTime,
            description: data.description,
            //  patientId: data.patientName,
            patientId: this.PatName,        // [this.personalInfo[0].lastName, this.personalInfo[0].firstName, this.personalInfo[0].middleName].filter(Boolean).join(", ") + ' ' + this.personalInfo[0].suffix,
            //   driverName: data.driverName,
            visitDate: data.visitDate,
            isActive: data.isActive
          });

          if (data.patientSignature != "" && data.patientSignature != null) {
            // this.signaturePad.fromDataURL('data:image/png;base64,' + data.patientSignature);
            // var canvas = document.getElementById('cnv') as HTMLCanvasElement;
            // var ctx = canvas.getContext("2d");
            // var image = new Image();
            // image.onload = function () {
            //   ctx.drawImage(image, 0, 0);
            // };
            // image.src = "data:image/png;base64," + data.patientSignature;

            setTimeout(() => {

              this.signaturePad.fromDataURL('data:image/png;base64,' + data.patientSignature);
              var canvas = document.getElementById('cnv') as HTMLCanvasElement;
              var ctx = canvas.getContext("2d");
              //  this.medAdmTime1.nativeElement.focus();
              var image = new Image();

              image.onload = function () {
                ctx.drawImage(image, 111, 300);
              };

              image.src = "data:image/png;base64," + data.patientSignature;
            }, 500);

          }
        }
      })
    }
  }
  // navigateBack(){
  //   this.router.navigate(['Demographics/Forms']);
  // }

  startSignaturePad1() {
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "assets/SignaturePad/SignaturePadHandler1.js";
    document.getElementsByTagName("head")[0].appendChild(script);

    script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "assets/SignaturePad/SigWebTablet.js";
    document.getElementsByTagName("head")[0].appendChild(script);
  }

  chkESignature: boolean = false;
  IsPadNotLCD: boolean = true;
  IsPadLCD: boolean = true;
  modelNumberTablet: number = -1;
  IsPadNotLCD1: boolean = true;
  IsPadLCD1: boolean = true;
  modelNumberTablet1: number = -1;
  count: number = 0;
  count1: number = 0;
  eSignCount: number = 0
  eSignCount1: number = 0
  clickButtonType: string = "";
  onclickTablet1(eve, signType) {
    // this.clickButtonType = signType
    // if (signType === "PatientSign") {
    //   if (document.getElementById("softwareCheck").innerHTML == "false" || document.getElementById("softwareCheck").innerHTML == '') {
    //     this.softwareInstalled = false;
    //     if (this.count == 0) {
    //       this.count++
    //     } else {
    //       this.toastr.error("Software Not Install");
    //     }
    //     this.MyMouseSignaturePad = true;
    //     this.signPadcheck = false;
    //   } else {
    //     this.signaturePad1 = true;

    //     if (document.getElementById("tabletStateCheck").innerHTML != "" && document.getElementById("tabletStateCheck").innerHTML != null && document.getElementById("tabletStateCheck").innerHTML != undefined) {
    //       if (document.getElementById("tabletStateCheck").innerHTML == "true") {
    //         this.modelNumberTablet = Number(document.getElementById("displayModelNumber").innerHTML);
    //         if (document.getElementById("displayModelNumber").innerHTML == "0") {
    //           document.getElementById('sigImageDataPatient')["value"] = 'Base64String: ';
    //           this.signaturePad1 = false;
    //           //     this.toastr.error("Signature pad Not connected");
    //           //   //  this.toastr.info("Software Installed");
    //           // this.MyMouseSignaturePad = true;
    //           this.signPadcheck = true;

    //           this.chkESignature = true;
    //           //  this.EnterDefaultDateTime('PatientsignoffDateTime')
    //           //  this.EnterDefaultDateTime("PatientSignOffDateTime");
    //           this.MyMouseSignaturePad = false;
    //           this.IsPadNotLCD = false;
    //           this.IsPadLCD = true;
    //           // clear sign from canvas
    //           var canvas = document.getElementById("cnvnotLCD") as HTMLCanvasElement;
    //           var context = canvas.getContext('2d');
    //           context.clearRect(0, 0, canvas.width, canvas.height);
    //         } else {
    //           //     // alert('connected ')
    //           this.signaturePad1 = true;
    //           //  this.toastr.info("Signature pad connected");
    //           //  this.toastr.info("Software Installed");
    //           //     this.MyMouseSignaturePad = false;
    //           this.signPadcheck = true;
    //           // this.getdatetime('PatientsignoffDateTime');
    //           //this.getdatetime('othsignoffDateTime');
    //           document.getElementById('sigImageDataPatient')["value"] = 'Base64String: ';
    //           this.chkESignature = true;
    //           this.MyMouseSignaturePad = false;
    //           this.IsPadNotLCD = true;
    //           this.IsPadLCD = false;
    //           // clear sign from canvas
    //           var canvas = document.getElementById("cnv") as HTMLCanvasElement;
    //           var context = canvas.getContext('2d');
    //           context.clearRect(0, 0, canvas.width, canvas.height);
    //         }

    //       } else {
    //         if (this.eSignCount == 0) {
    //           this.eSignCount++;
    //           setTimeout(() => {
    //             $("#EsignPatientSignOff").click();
    //           }, 2000);

    //         } else {
    //           this.toastr.error("Device Not Connected");
    //           this.MyMouseSignaturePad = true;
    //           this.IsPadNotLCD = true;
    //           this.IsPadLCD = true;
    //           return;
    //         }
    //       }
    //     } else {
    //       this.MyMouseSignaturePad = true;
    //       return;
    //     }

    //     // //this.toastr.info("Software Installed");
    //     // //Device Connected or not
    //     // if (document.getElementById("checkTablet").innerHTML != "" && document.getElementById("checkTablet").innerHTML != null && document.getElementById("checkTablet").innerHTML != undefined) {
    //     //   if (document.getElementById("checkTablet").innerHTML == "false") {
    //     //     this.signaturePad1 = false;
    //     //     this.toastr.error("Signature pad Not connected");
    //     //   //  this.toastr.info("Software Installed");
    //     //     this.MyMouseSignaturePad = true;
    //     //     this.signPadcheck = false;
    //     //   } else {
    //     //     // alert('connected ')
    //     //     this.signaturePad1 = true;
    //     //   //  this.toastr.info("Signature pad connected");
    //     //   //  this.toastr.info("Software Installed");
    //     //     this.MyMouseSignaturePad = false;
    //     //     this.signPadcheck = true;
    //     //     var canvas = document.getElementById("cnv") as HTMLCanvasElement;
    //     //     var context = canvas.getContext('2d');
    //     //     context.clearRect(0, 0, canvas.width, canvas.height);
    //     //     this.getdatetime('PatientsignoffDateTime');
    //     //     //this.getdatetime('othsignoffDateTime');
    //     //   }
    //     // }
    //     // else {
    //     //   this.signaturePad1 = false;
    //     //   // this.toastr.error("Signature pad Not connected");
    //     //   this.MyMouseSignaturePad = true;
    //     //   this.signPadcheck = false;
    //     // }


    //   }
    // } else {
    //   ;
    //   if (document.getElementById("softwareCheck1").innerHTML == "false" || document.getElementById("softwareCheck1").innerHTML == '') {
    //     this.softwareInstalled1 = false;
    //     if (this.count1 == 0) {
    //       this.count1++
    //     } else {
    //       this.toastr.error("Software Not Install");

    //     }
    //     this.MyMouseSignaturePad1 = true;
    //     this.signPadcheck = false;
    //   } else {
    //     this.signaturePad3 = true;

    //     if (document.getElementById("tabletStateCheck1").innerHTML != "" && document.getElementById("tabletStateCheck1").innerHTML != null && document.getElementById("tabletStateCheck1").innerHTML != undefined) {
    //       if (document.getElementById("tabletStateCheck1").innerHTML == "true") {
    //         this.modelNumberTablet1 = Number(document.getElementById("displayModelNumber1").innerHTML);
    //         if (document.getElementById("displayModelNumber1").innerHTML == "0") {
    //           document.getElementById('sigImageData1')["value"] = 'Base64String: ';
    //           this.signaturePad1 = false;
    //           //     this.toastr.error("Signature pad Not connected");
    //           //   //  this.toastr.info("Software Installed");
    //           this.MyMouseSignaturePad1 = false;
    //           this.signPadcheck = true;

    //           this.chkESignature = true;
    //           // this.EnterDefaultDateTime("PatientSignOffDateTime");
    //           // this.MyMouseSignaturePad = false;
    //           this.IsPadNotLCD1 = false;
    //           this.IsPadLCD1 = true;
    //           // clear sign from canvas
    //           var canvas = document.getElementById("cnvnotLCD1") as HTMLCanvasElement;
    //           var context = canvas.getContext('2d');
    //           context.clearRect(0, 0, canvas.width, canvas.height);
    //         } else {
    //           //     // alert('connected ')
    //           this.signaturePad1 = true;
    //           //  this.toastr.info("Signature pad connected");
    //           //  this.toastr.info("Software Installed");
    //           //     this.MyMouseSignaturePad = false;
    //           this.signPadcheck = true;
    //           // this.getdatetime('othsignoffDateTime');
    //           //this.getdatetime('othsignoffDateTime');
    //           document.getElementById('sigImageData1')["value"] = 'Base64String: ';
    //           this.chkESignature = true;
    //           this.MyMouseSignaturePad1 = false;
    //           this.IsPadNotLCD1 = true;
    //           this.IsPadLCD1 = false;
    //           // clear sign from canvas
    //           var canvas = document.getElementById("cnv1") as HTMLCanvasElement;
    //           var context = canvas.getContext('2d');
    //           context.clearRect(0, 0, canvas.width, canvas.height);
    //         }

    //       } else {
    //         if (this.eSignCount1 == 0) {
    //           this.eSignCount1++;
    //           setTimeout(() => {
    //             $("#EsignOtherSignOff").click();
    //           }, 2000);

    //         } else {
    //           this.toastr.error("Device Not Connected");
    //           this.MyMouseSignaturePad1 = true;
    //           this.IsPadNotLCD1 = true;
    //           this.IsPadLCD1 = true;
    //           return;
    //         }
    //       }
    //     } else {
    //       this.MyMouseSignaturePad1 = true;
    //       return;
    //     }

    //     // if (document.getElementById("tabletStateCheck1").innerHTML != "" && document.getElementById("tabletStateCheck1").innerHTML != null && document.getElementById("tabletStateCheck1").innerHTML != undefined) {
    //     //   if (document.getElementById("tabletStateCheck1").innerHTML == "true") {
    //     //     this.modelNumberTablet = Number(document.getElementById("displayModelNumber1").innerHTML);
    //     //     if (document.getElementById("displayModelNumber1").innerHTML == "0") {
    //     //       document.getElementById('sigImageData1')["value"] = 'Base64String: ';
    //     //       this.signaturePad1 = false;
    //     //       //     this.toastr.error("Signature pad Not connected");
    //     //       //   //  this.toastr.info("Software Installed");
    //     //       this.MyMouseSignaturePad = true;
    //     //       this.signPadcheck = false;

    //     //       this.chkESignature = true;
    //     //       this.EnterDefaultDateTime("PatientSignOffDateTime");
    //     //       // this.MyMouseSignaturePad = false;
    //     //       this.IsPadNotLCD = false;
    //     //       this.IsPadLCD = true;
    //     //       // clear sign from canvas
    //     //       var canvas = document.getElementById("cnvnotLCD") as HTMLCanvasElement;
    //     //       var context = canvas.getContext('2d');
    //     //       context.clearRect(0, 0, canvas.width, canvas.height);
    //     //     } else {
    //     //       //     // alert('connected ')
    //     //       this.signaturePad1 = true;
    //     //       //  this.toastr.info("Signature pad connected");
    //     //       //  this.toastr.info("Software Installed");
    //     //       //     this.MyMouseSignaturePad = false;
    //     //       this.signPadcheck = true;
    //     //       this.getdatetime('PatientsignoffDateTime');
    //     //       //this.getdatetime('othsignoffDateTime');
    //     //       document.getElementById('sigImageData')["value"] = 'Base64String: ';
    //     //       this.chkESignature = true;
    //     //       this.MyMouseSignaturePad = false;
    //     //       this.IsPadNotLCD = true;
    //     //       this.IsPadLCD = false;
    //     //       // clear sign from canvas
    //     //       var canvas = document.getElementById("cnv") as HTMLCanvasElement;
    //     //       var context = canvas.getContext('2d');
    //     //       context.clearRect(0, 0, canvas.width, canvas.height);
    //     //     }

    //     //   } else {
    //     //     this.toastr.error("Device Not Connected");
    //     //     this.MyMouseSignaturePad = true;
    //     //     this.IsPadNotLCD = true;
    //     //     this.IsPadLCD = true;
    //     //     return;
    //     //   }
    //     // } else {
    //     //   this.MyMouseSignaturePad = true;
    //     //   return;
    //     // }

    //     // //this.toastr.info("Software Installed");
    //     // //Device Connected or not
    //     // if (document.getElementById("checkTablet1").innerHTML != "" && document.getElementById("checkTablet1").innerHTML != null && document.getElementById("checkTablet1").innerHTML != undefined) {
    //     //   if (document.getElementById("checkTablet1").innerHTML == "false") {
    //     //     this.signaturePad3 = false;
    //     //     this.toastr.error("Signature pad Not connected");
    //     //     // this.toastr.info("Software Installed");
    //     //     this.MyMouseSignaturePad1 = true;
    //     //     this.signPadcheck = false;
    //     //   } else {
    //     //     this.signaturePad3 = true;
    //     //     // this.toastr.info("Signature pad connected");
    //     //     //  this.toastr.info("Software Installed");
    //     //     this.MyMouseSignaturePad1 = false;
    //     //     this.signPadcheck = true;
    //     //     var canvas = document.getElementById("cnv1") as HTMLCanvasElement;
    //     //     var context = canvas.getContext('2d');
    //     //     context.clearRect(0, 0, canvas.width, canvas.height);
    //     //     //this.getdatetime('PatientsignoffDateTime');
    //     //     this.getdatetime('othsignoffDateTime');
    //     //   }
    //     // }
    //     // else {
    //     // //  alert()
    //     //   this.signaturePad3 = false;
    //     //   // this.toastr.error("Signature pad Not connected");
    //     //   this.MyMouseSignaturePad1 = true;
    //     //   this.signPadcheck = false;
    //     // }
    //   }
    // }


  }

  onDoubleClick(type: string) {
    if (type == 'PracticeForm') {
      this.EditForms.patchValue({
        practiceForm: ''
      })
      document.getElementById('effectiveDate').focus();
      document.getElementById('cd').focus();
    } else if (type == 'NurseId') {
      this.EditForms.patchValue({
        NurseId: ''
      })
      document.getElementById('NurseDateTime').focus();
      document.getElementById('NurseId').focus();
    } else if (type == 'ClerkId') {
      this.EditForms.patchValue({
        ClerkId: ''
      })
      document.getElementById('clerkDatetime').focus();
      document.getElementById('ClerkId').focus();
    }
    else if (type == 'ProviderID') {
      this.EditForms.patchValue({
        ProviderID: ''
      })
      document.getElementById('providerdatetime').focus();
      document.getElementById('ProviderID').focus();
    }
  }

  ConsentFormMasterOptions: Observable<IConsentNameMasterData_DocLibAll[]>;
  nurseIdOptions: Observable<IUserDetails[]>;
  clerkptions: Observable<IUserDetails[]>;
  providerNameOptions: Observable<IUserDetails[]>;

  ConsentNameMasterDatafilter() {
    this.ConsentFormMasterOptions = this.EditForms.get('practiceForm')!.valueChanges.pipe(
      startWith(""),
      map(value => this._ConsentNameMasterData(value))
    );
  }
  private _ConsentNameMasterData(value: string): IConsentNameMasterData_DocLibAll[] {
    if (value != null) {
      const filterValue = value.toString().toLowerCase();
      return this.consentNameMasterDetails.filter(option => option.ConsentName.toLowerCase().indexOf(filterValue) === 0);
    }
  }

  nurseIdfilter() {
    this.nurseIdOptions = this.EditForms.get('NurseId')!.valueChanges.pipe(
      startWith(""),
      map(value => this._nurseId(value))
    );
  }
  private _nurseId(value: string): IUserDetails[] {
    if (value != null) {
      const filterValue = value.toString().toLowerCase();
      return this.providersNurseList.filter(option => option.fullName.toLowerCase().indexOf(filterValue) === 0);
    }
  }

  providerNamefilter() {
    this.providerNameOptions = this.EditForms.get('ProviderID')!.valueChanges.pipe(
      startWith(""),
      map(value => this._providerName(value))
    );
  }
  private _providerName(value: string): IUserDetails[] {
    if (value != null) {
      const filterValue = value.toString().toLowerCase();
      return this.providersDocList.filter(option => option.fullName.toLowerCase().indexOf(filterValue) === 0);
    }
  }

  clerkNamefilter() {

    this.clerkptions = this.EditForms.get('ClerkId')!.valueChanges.pipe(
      startWith(""),
      map(value => this._clerkName(value))
    );
  }
  private _clerkName(value: string): IUserDetails[] {
    if (value != null) {
      const filterValue = value.toString().toLowerCase();
      return this.providersClerkList.filter(option => option.fullName.toLowerCase().indexOf(filterValue) === 0);
    }
  }

  cmbnotes: string;
  consentNameId: number;
  signNurseId: string;
  clerkNameId: string;
  providerNameId: string;
  onSelectionChanged(event, type: string) {
    try {
      setTimeout(() => {
        if (event !== null && event !== undefined) {
          $('#test').prev().trigger('focus');
        }
      }, 100);

      if (this.cmbnotes == event)
        return;

      this.cmbnotes = event
      if (type === "PracticeForm") {
        let consentNamelist = this.consentNameMasterDetails.filter(x => x.ConsentName === this.cmbnotes);
        this.consentNameId = 0;
        if (consentNamelist.length != 0) {
          this.consentNameId = consentNamelist[0].MasterConsentId;
          this.onSelectionChange(this.consentNameId);
        } else {
          //this.ConsentForm.activeOption.value=null;
          this.labelHtml = "<div>&nbsp;</div>";
          this.initEditor.setContents(this.labelHtml);
          this.consentNameId = 0;
          document.getElementById('effectiveDate').focus();
          document.getElementById('cd').focus();
        }
      } else if (type === "NurseId") {
        let nurseobj = this.providersNurseList.filter(x => x.fullName === this.cmbnotes);
        if (nurseobj.length != 0) {
          this.signNurseId = nurseobj[0].userId;
          this.nurseSelectionChange();
        } else {
          this.signNurseId = "0";
          this.nurseSelectionChange();
        }
      } else if (type === "ClerkId") {
        let clerkObj = this.providersClerkList.filter(x => x.fullName === this.cmbnotes);
        if (clerkObj.length != 0) {
          this.clerkNameId = clerkObj[0].userId;
        } else {
          this.clerkNameId = "0";
        }
      } else if (type === "ProviderID") {
        let provideObj = this.providersDocList.filter(x => x.fullName === this.cmbnotes);
        if (provideObj.length != 0) {
          this.providerNameId = provideObj[0].userId;
        } else {
          this.providerNameId = "0";
        }
      }
      //this.spinner.hide();
    }
    catch (ex) {//this.spinner.hide();
      this.showspinner = false;
    }
    finally {
      // this.spinner.hide;
      setTimeout(() => {

        $(event.target).focus();
        if ($(event.target).value && $(event.target).value.length > 1)
          $(event.target).setSelectionRange(2, 2);

      }, 1);
      // setTimeout(() => {

      //   let singlequotetextctrls = $("#suneditor_Formseditor p span");
      //   let strongspans = $("#suneditor_Formseditor p span");
      //   let spanstrongspan = $("#suneditor_Formseditor p span span");  
      //   let spanspanstrong = $("#suneditor_Formseditor p span span");    
      //   let allitems = [...singlequotetextctrls, ...strongspans, ...spanstrongspan, ...spanspanstrong];        
      //   let filteritems = allitems.filter(x=> x.textContent.includes('"'));        
      //   if(filteritems != (null || undefined) && filteritems.length > 0){
      //     $.each(filteritems, (i, item)=> {
      //       if($(item) != (null || undefined) && $(item)[0].textContent != (null || undefined)){              
      //         let spanText = $(item)[0].textContent;
      //         var spancssText = $(item)[0].style.cssText;
      //         if($(item)[0].innerHTML.includes("<strong>")){
      //           $($(item)[0]).html("<strong>" + spanText.replace(/\"/g, "'") + "</strong>");
      //         }
      //         else{
      //           $($(item)[0]).html(spanText.replace(/\"/g, "'"));
      //         }
      //         //$(item)[0].innerText = spanText.replace(/\"/g, "'");
      //         //$(item)[0].attr("style", spancssText);
      //       }
      //     });
      //   }
      //   var paragrahtags = [...$("#suneditor_Formseditor div").find("p")];
      //   let allptags = paragrahtags.filter(x => x.innerText.includes('"'));
      //   if(allptags != (null || undefined) && allptags.length > 0){
      //     $.each(allptags, (i, item)=> {
      //       if($(item) != (null || undefined) && $(item)[0].innerText != (null || undefined)){
      //         let innerText = $(item)[0].innerText;
      //         $(item)[0].innerText = innerText.replace(/\"/g, "'");              
      //       }
      //     });
      //   }    
      // }, 500);
    }
  }

  async autoCompleteValueBind(doclibobj: any, type: string) {

    if (type == "PracticeForm") {
      if (this.consentNameMasterDetails == undefined) {
        //await this.getAllProviders("Doctor");

        setTimeout(() => {
          var docobj = this.consentNameMasterDetails.filter(x => x.MasterConsentId == doclibobj);
          if (docobj.length != 0) {
            this.EditForms.controls.practiceForm.setValue(docobj[0].ConsentName);
          }
        }, 1000);
      }
      else {
        var docobj = this.consentNameMasterDetails.filter(x => x.MasterConsentId == doclibobj);
        if (docobj.length != 0) {
          this.EditForms.controls.practiceForm.setValue(docobj[0].ConsentName);
        }
      }
    } else if (type == "NurseId") {

      if (this.providersNurseList == undefined) {
        await this.getAllProviders("Nurse");

        setTimeout(() => {
          var monatring = this.providersNurseList.filter(x => x.userId == doclibobj);
          if (monatring.length != 0) {
            this.EditForms.controls.NurseId.setValue(monatring[0].fullName);
          }

        }, 1000);
      } else {

        var monatring = this.providersNurseList.filter(x => x.userId == doclibobj);
        if (monatring.length != 0) {
          this.EditForms.controls.NurseId.setValue(monatring[0].fullName);
        }
      }
    }
    else if (type == "ClerkId") {
      if (this.providersClerkList == undefined) {
        await this.getAllProviders("Clerk");

        setTimeout(() => {
          var clerkNameObj = this.providersClerkList.filter(x => x.userId == doclibobj);
          if (clerkNameObj.length != 0) {
            this.EditForms.controls.ClerkId.setValue(clerkNameObj[0].fullName);
          }

        }, 1000);
      }
      else {
        var clerkNameObj = this.providersClerkList.filter(x => x.userId == doclibobj);
        if (clerkNameObj.length != 0) {
          this.EditForms.controls.ClerkId.setValue(clerkNameObj[0].fullName);
        }
      }
    } else if (type == "ProviderID") {

      if (this.providersDocList == undefined) {
        await this.getAllProviders("Doctor");

        setTimeout(() => {
          var provideObj = this.providersDocList.filter(x => x.userId == doclibobj);
          if (provideObj.length != 0) {
            this.EditForms.controls.ProviderID.setValue(provideObj[0].fullName);
          } else {
            this.EditForms.controls.ProviderID.setValue("");
          }

        }, 1000);
      }
      else {
        var provideObj = this.providersDocList.filter(x => x.userId == doclibobj);
        if (provideObj.length != 0) {
          this.EditForms.controls.ProviderID.setValue(provideObj[0].fullName);
        } else {
          this.EditForms.controls.ProviderID.setValue("");
        }
      }
    }
  }
  onKey1(event, AutoName) {
    var txtVal = event.target.value;
    if (AutoName === "PracticeForm") {
      let consentNameList = this.consentNameMasterDetails.filter(x => x.ConsentName === txtVal);
      if (consentNameList.length == 0) {
        this.EditForms.controls.practiceForm.setValue('');
      }

    } else if (AutoName === "NurseId") {
      let ivFluidsList = this.providersNurseList.filter(x => x.fullName === txtVal);
      if (ivFluidsList.length == 0) {
        this.EditForms.controls.NurseId.setValue('');
      }

    } else if (AutoName === "ClerkId") {
      let clerkIdObj = this.providersClerkList.filter(x => x.fullName === txtVal);
      if (clerkIdObj.length == 0) {
        this.EditForms.controls.ClerkId.setValue('');
      }
    } else if (AutoName === "ProviderID") {
      let provideNameObj = this.providersDocList.filter(x => x.fullName === txtVal);
      if (provideNameObj.length == 0) {
        this.EditForms.controls.ProviderID.setValue('');
      }
    }
  }

  ngAfterViewInit() {
    try {
      this.ConsentForm.panelClosingActions.subscribe(x => {
        if (this.ConsentForm.activeOption) {
          this.EditForms.patchValue({
            practiceForm: this.ConsentForm.activeOption.value
          });
        }
      });

      this.nurseName.panelClosingActions.subscribe(x => {
        if (this.nurseName.activeOption) {
          this.EditForms.patchValue({
            NurseId: this.nurseName.activeOption.value
          });
        }
      });

      this.clerkName.panelClosingActions.subscribe(x => {
        if (this.clerkName.activeOption) {
          this.EditForms.patchValue({
            ClerkId: this.clerkName.activeOption.value
          });
        }
      });

      this.providerName.panelClosingActions.subscribe(x => {
        if (this.providerName.activeOption) {
          this.EditForms.patchValue({
            ProviderID: this.providerName.activeOption.value
          });
        }
      });
    }

    catch (ex) { }
    finally {

    }
  }
  tabletDoneCheck: boolean = true;
  tabletDoneCheck1: boolean = true;
  onDone_click(type: string) {
    if (type == 'PatientSignature') {
      if (document.getElementById("tabletDoneCheck").innerHTML == "false") {
        this.EnterDefaultDateTime('PatientsignoffDateTime')
        this.toastr.success('Signature Captured Successfully!')
      } else {
        this.toastr.error('Please Enter signature before click on Accept button')
      }
    } else if (type === 'OtherSignature') {
      if (document.getElementById("tabletDoneCheck1").innerHTML == "false") {
        this.EnterDefaultDateTime('othsignoffDateTime')
        this.toastr.success('Signature Captured Successfully!')
      } else {
        this.toastr.error('Please Enter signature before click on Accept button')
      }
    }

  }

  public sub: Subscription;
  refreshServerDateTime() {
    // this.sub = Observable.interval(1000).subscribe((val) => { this.serverCurrentDateTime() });
    this.serverCurrentDateTime();
  }

  // serverCurrentDateTime() {
  //   this.dateservice.getservercurrentdate().subscribe(async result => {
  //     await result;
  //     this.currentlocationdate = formatDate(result, 'MM-dd-yyyy hh:mm:ss a', 'en-US');
  //   });
  // }
  LocationTimer: any;
  LocationTimer_DateFormat: Date;
  serverCurrentDateTime() {
    this.dateservice.getservercurrentdate().subscribe(result => {
      this.LocationTimer_DateFormat = new Date(result);
      this.currentlocationdate = formatDate(result, 'MM-dd-yyyy hh:mm:ss a', 'en-US');
      // result = this.datePipe.transform(result, "MM/dd/yyyy hh:mm:ss a");
      //this.LocationTimer = result.replace('T', ' ');

      setInterval(() => {
        this.LocationTimer_DateFormat.setSeconds(this.LocationTimer_DateFormat.getSeconds() + 1)
        // this.LocationTimer = this.datePipe.transform(this.LocationTimer_DateFormat, "MM/dd/yyyy hh:mm:ss a").replace('T', ' ');
        this.currentlocationdate = formatDate(this.LocationTimer_DateFormat, 'MM-dd-yyyy hh:mm:ss a', 'en-US');
      }, 1000);

    })
  }

  removejscssfile(filename, filetype) {
    // var targetelement = (filetype == "js") ? "script" : (filetype == "css") ? "link" : "none" //determine element type to create nodelist from
    // var targetattr = (filetype == "js") ? "src" : (filetype == "css") ? "href" : "none" //determine corresponding attribute to test for
    // var allsuspects = document.getElementsByTagName(targetelement)
    // for (var i = allsuspects.length; i >= 0; i--) { //search backwards within nodelist for matching elements to remove

    //   if (allsuspects[i] && allsuspects[i].getAttribute(targetattr) != null && allsuspects[i].getAttribute(targetattr).indexOf(filename) != -1)

    //     allsuspects[i].parentNode.removeChild(allsuspects[i]) //remove element by calling parentNode.removeChild()
    // }
  }

  Onclick_SingnaturePOP_(Type) {

    Onclick_SingnaturePOP(Type);

  }

  checkSignaturePop: boolean = false;
  SignatureCheckIdWitness: boolean = false;
  onClickCheckSignature() {
    this.checkSignaturePop = true;
    this.signPadcheckPatient = true;
    this.getdatetime('PatientsignoffDateTime');
    //this.EnterDefaultDateTime('vertiflexPhySignOffDateTime');
  }
  onClickCheckSignatureWitness() {
    this.SignatureCheckIdWitness = true;
    this.signPadcheckWitness = true;
    this.getdatetime('othsignoffDateTime');

  }
  Backtodashboard() {
    //this.router.navigateByUrl('/providerdashboard');
    this.router.navigateByUrl('/', { skipLocationChange: true, queryParamsHandling: 'preserve' }).then(() =>
      this.router.navigateByUrl('/providerdashboard?isPN=true'));

  }

}


